(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wf-beverage-formula-calculator"] && !Shopify.designMode) return;
  try {
    
var wfT = window.wfI18n || function(message, values = []) { return message.replace(/\{(\d+)\}/g, (_, i) => String(values[Number(i)] ?? '')); };
var wfH = function(message, values = []) { return wfT(message, values).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); };

const CALCULATOR_SELECTOR = '[data-wf-beverage-calculator]';
const ML_PER_US_OZ = 29.5735295625;
const ML_PER_US_GALLON = 3785.411784;
const MAX_BATCH_LITRES = 1000000;
const GRAMS_PER_POUND = 453.59237;
const GRAMS_PER_OUNCE = 28.349523125;
const MAX_TOTAL_USAGE_PERCENT = 100;
const UPSIZE_SAVING_THRESHOLD = 0.10;
const UPSIZE_TOTAL_MULTIPLIER = 1.5;

function initCalculator(root){
  if(!root || root.dataset.ready) return;
  window.wfI18n?.add?.(root.querySelector('[data-wf-french-dictionary]'));
  const FREIGHT_NOTE_TEXT = wfT("Freight quote required. We’ll confirm shipping before dispatch.");
  const EMPTY_PURCHASE_PLAN = { label:wfT("Size unavailable"), items:[], totalMl:0, totalPrice:0, leftoverMl:0, count:0 };
  root.dataset.ready = 'true';
  document.documentElement.classList.add('wfcalc2-page');

  const isFrench = (root.dataset.language || document.documentElement.lang || '').toLowerCase().startsWith('fr');
  const numberLocale = isFrench ? 'fr-CA' : 'en-US';
  const moneySymbol = String(root.dataset.moneySymbol ?? '$');
  const defaultBatchSize = Number(root.dataset.defaultBatch) || 1000;
  const defaultUsage = Number(root.dataset.defaultUsage) || 0.2;
  const implausibleUsageThreshold = Number(root.dataset.usageNoteThreshold) || 5;
  const policy = Object.freeze({
    headroomTarget:Number(root.dataset.headroomTargetPercent) / 100,
    simplicityBand:Number(root.dataset.simplicityBandPercent) / 100,
    maxRecommendationSizeTypes:Math.max(1, Math.floor(Number(root.dataset.maxRecommendationSizeTypes))),
    maxSmallFormatUnits:Math.max(1, Math.floor(Number(root.dataset.maxSmallFormatUnits))),
    smallFormatMaxMl:Math.max(1, Number(root.dataset.smallFormatMaxMl)),
    toteUnlockGallons:Math.max(1, Number(root.dataset.toteUnlockGallons)),
    cheaperPlanSavingsTolerance:Number(root.dataset.cheaperPlanSavingsTolerancePercent) / 100
  });
  const catalogueProducts = safeJson(root.querySelector('[data-wf-products]')?.textContent, []);
  const catalogueCurrent = safeJson(root.querySelector('[data-wf-current-product]')?.textContent, null);
  // Keep the server-rendered display names when search and product APIs return raw titles.
  const catalogueTitles = new Map([...catalogueProducts, catalogueCurrent].filter(Boolean).map(p => [
    sanitizeProductHandle(Array.isArray(p) ? p[1] : p.handle),
    Array.isArray(p) ? p[0] : p.title
  ]));
  const embedded = catalogueProducts.map(normalizeProduct);
  const current = normalizeProduct(catalogueCurrent);
  const products = dedupeProducts([current, ...embedded].filter(Boolean));

  const rowsEl = root.querySelector('[data-wf-rows]');
  const weightRowsEl = root.querySelector('[data-wf-weight-rows]');
  const weightHeadingEl = root.querySelector('[data-wf-weight-heading]');
  const calculationDetailsEl = root.querySelector('[data-wf-calculation-details]');
  const purchaseEl = root.querySelector('[data-wf-purchase]');
  const purchaseListEl = root.querySelector('[data-wf-purchase-list]');
  const cartStatusEl = root.querySelector('[data-wf-cart-status]');
  const addAllBtn = root.querySelector('[data-wf-add-all]');
  const addAllBtnText = root.querySelector('[data-wf-add-all-text]');
  const volumeContactEl = root.querySelector('[data-wf-volume-contact]');
  const addRowBtn = root.querySelector('[data-wf-add-row]');
  const addRowStatusEl = root.querySelector('[data-wf-add-row-status]');
  const resetBtn = root.querySelector('[data-wf-reset]');
  const totalUsageEl = root.querySelector('[data-wf-total-usage]');
  const costVolumeLabelEl = root.querySelector('[data-wf-cost-volume-label]');
  const costPerVolumeEl = root.querySelector('[data-wf-cost-per-volume]');
  const copyFormulaBtn = root.querySelector('[data-wf-copy-formula]');
  const copyStatusEl = root.querySelector('[data-wf-copy-status]');
  const detailsCostUsedEl = root.querySelector('[data-wf-details-cost-used]');
  const targetPackagesEl = root.querySelector('[data-wf-target-packages]');
  const targetPackageSizeEl = root.querySelector('[data-wf-target-package-size]');
  const targetCustomPackageEl = root.querySelector('[data-wf-target-custom-package]');
  const targetCustomUnitEl = root.querySelector('[data-wf-target-custom-unit]');
  const targetCustomWrap = root.querySelector('.wfcalc2__target-custom-package');
  const targetResultEl = root.querySelector('[data-wf-target-result]');
  const targetApplyButtons = [...root.querySelectorAll('[data-wf-apply-target]')];
  targetApplyButtons.slice(1).forEach(button => button.remove());
  const targetApplyButton = targetApplyButtons[0] || null;
  const testBatchPanelEl = root.querySelector('[data-wf-test-batch-panel]');
  const batchBuilderEl = root.querySelector('[data-wf-batch-builder]');
  const testBatchTargetEl = root.querySelector('[data-wf-test-target]');
  const testBatchSizeEl = root.querySelector('[data-wf-test-size]');
  const testBatchUnitEl = root.querySelector('[data-wf-test-unit]');
  const testBatchFlavourUsedEl = root.querySelector('[data-wf-test-flavour-used]');
  const testBatchFlavourUnitEl = root.querySelector('[data-wf-test-flavour-unit]');
  const testBatchApplyEl = root.querySelector('[data-wf-apply-test-batch]');
  const testBatchResultEl = root.querySelector('[data-wf-test-result]');
  const needLabelEl = root.querySelector('[data-wf-need-label]');
  const needMainEl = root.querySelector('[data-wf-need-main]');
  const needCaptionEl = root.querySelector('[data-wf-need-caption]');
  const needSubEl = root.querySelector('[data-wf-need-sub]');
  const resultCurrencyEl = root.querySelector('[data-wf-result-currency]');
  const pricingPromptEl = root.querySelector('[data-wf-pricing-prompt]');
  const packageSettingsEl = root.querySelector('[data-wf-package-settings]');
  const toolsEl = root.querySelector('[data-wf-tools]');
  const orderSummaryEl = root.querySelector('[data-wf-order-summary]');
  const quickMetricsEl = root.querySelector('[data-wf-quick-metrics]');
  const summaryPackageCostEl = root.querySelector('[data-wf-summary-package-cost]');
  const summaryCostUsedEl = root.querySelector('[data-wf-cost-used-summary]');
  const summarySpareEl = root.querySelector('[data-wf-spare-summary]');
  const orderTotalEl = root.querySelector('[data-wf-order-total]');
  const packageCostLabelEl = root.querySelector('[data-wf-package-cost-label]');
  const orderExclusionsEl = root.querySelector('[data-wf-order-exclusions]');
  const totalUsageNoteEl = root.querySelector('[data-wf-total-note]');
  const purchaseHeadingEl = root.querySelector('[data-wf-purchase-heading]');
  const mobileNeedEl = root.querySelector('[data-wf-mobile-need]');
  const mobilePackageLabelEl = root.querySelector('[data-wf-mobile-package-label]');
  const mobilePackageCostEl = root.querySelector('[data-wf-mobile-package-cost]');
  const mobileSummaryEl = root.querySelector('[data-wf-mobile-summary]');
  const viewOrderBtn = root.querySelector('[data-wf-view-order]');
  const batchSizeEl = root.querySelector('[data-wf-batch-size]');
  const batchErrorEl = root.querySelector('[data-wf-batch-error]');
  const batchUnitEl = root.querySelector('[data-wf-batch-unit]');
  const packageEl = root.querySelector('[data-wf-package-size]');
  const customPackageUnitEl = root.querySelector('[data-wf-custom-package-unit]');
  const customPackageWrap = root.querySelector('.wfcalc2__custom-package');
  const customPackageEl = root.querySelector('[data-wf-custom-package]');
  const resultEl = root.querySelector('.wfcalc2__result');
  const basisNoticeEl = root.querySelector('[data-wf-basis-notice]');
  const basisMessageEl = root.querySelector('[data-wf-basis-message]');
  const confirmBasisEl = root.querySelector('[data-wf-confirm-basis]');
  const calculationNoteEl = root.querySelector('[data-wf-calculation-note]');
  const targetYieldEl = root.querySelector('[data-wf-target-yield]');
  const finishedCountEl = root.querySelector('[data-wf-finished-count]');
  const finishedCountWrap = root.querySelector('[data-wf-finished-count-wrap]');
  const mixtureDensityEl = root.querySelector('[data-wf-mixture-density]');
  const mixtureDensityWrap = root.querySelector('[data-wf-mixture-density-wrap]');
  const packageNoteEl = root.querySelector('[data-wf-package-note]');
  const state = {
    rows: [],
    confirmedBasis:'volume',
    packageTouched:false,
    testBatch:{ targetRowId:'', size:250, unit:'ml', flavourUsed:0.5, flavourUnit:'ml', result:'' }
  };
  let orderVisibilityObserver = null;
  let calculatorVisibilityObserver = null;
  let mobileSummaryResizeObserver = null;
  let mobileSummaryFrame = 0;
  let mobileSummaryPortal = null;
  let mobileSummarySpacer = null;
  let customPackageUnitTouched = false;
  let formulaSummaryText = '';
  const draftKey = `wf-calculator-draft:v1:${window.location.pathname.slice(getShopifyRoot().length)}:${root.id}`;
  const draftControls = {
    batchSize:batchSizeEl, batchUnit:batchUnitEl, packageSize:packageEl,
    customPackage:customPackageEl, customPackageUnit:customPackageUnitEl,
    finishedCount:finishedCountEl, mixtureDensity:mixtureDensityEl,
    targetPackages:targetPackagesEl, targetPackageSize:targetPackageSizeEl,
    targetCustomPackage:targetCustomPackageEl, targetCustomUnit:targetCustomUnitEl, targetYield:targetYieldEl,
    testSize:testBatchSizeEl, testUnit:testBatchUnitEl,
    testFlavourUsed:testBatchFlavourUsedEl, testFlavourUnit:testBatchFlavourUnitEl
  };
  let draftReady = false;
  let draftDirty = false;

  [toolsEl, testBatchPanelEl, batchBuilderEl, packageSettingsEl, calculationDetailsEl].forEach(detailsEl => {
    if(!detailsEl) return;
    detailsEl.open = false;
    const summaryEl = detailsEl.querySelector(':scope > summary');
    const syncExpandedState = () => summaryEl?.setAttribute('aria-expanded', detailsEl.open ? 'true' : 'false');
    syncExpandedState();
    detailsEl.addEventListener('toggle', syncExpandedState);
  });

  addRowBtn?.addEventListener('click', () => addRow(null));
  resetBtn?.addEventListener('click', resetCalculator);
  addAllBtn?.addEventListener('click', () => addItemsToCart(safeJson(addAllBtn.dataset.items || '[]', [])));
  copyFormulaBtn?.addEventListener('click', copyFormulaSummary);
  targetApplyButton?.addEventListener('click', applyTargetPackages);
  testBatchPanelEl?.addEventListener('toggle', updateTestBatchButtonLabel);
  testBatchTargetEl?.addEventListener('change', () => {
    state.testBatch.targetRowId = testBatchTargetEl.value;
    updateTestBatchResultPreview();
  });
  testBatchSizeEl?.addEventListener('input', () => {
    state.testBatch.size = testBatchSizeEl.value;
    updateTestBatchResultPreview();
  });
  testBatchUnitEl?.addEventListener('change', () => {
    state.testBatch.unit = testBatchUnitEl.value;
    updateTestBatchResultPreview();
  });
  testBatchFlavourUsedEl?.addEventListener('input', () => {
    state.testBatch.flavourUsed = testBatchFlavourUsedEl.value;
    updateTestBatchResultPreview();
  });
  testBatchFlavourUnitEl?.addEventListener('change', () => {
    state.testBatch.flavourUnit = testBatchFlavourUnitEl.value;
    updateTestBatchResultPreview();
  });
  testBatchApplyEl?.addEventListener('click', applyTestBatchMeasurements);
  targetPackageSizeEl?.addEventListener('change', () => {
    if(targetCustomWrap) targetCustomWrap.hidden = targetPackageSizeEl.value !== 'custom';
    updateTargetBatchButtonLabel();
  });
  targetPackagesEl?.addEventListener('input', updateTargetBatchButtonLabel);
  targetYieldEl?.addEventListener('input', updateTargetBatchButtonLabel);
  targetCustomPackageEl?.addEventListener('input', updateTargetBatchButtonLabel);
  targetCustomUnitEl?.addEventListener('change', updateTargetBatchButtonLabel);
  batchSizeEl?.addEventListener('input', () => {
    enforceBatchSizeLimit();
    formulaChanged();
  });
  customPackageEl?.addEventListener('input', formulaChanged);
  batchUnitEl?.addEventListener('change', handleBatchUnitChange);
  customPackageUnitEl?.addEventListener('change', () => {
    customPackageUnitTouched = true;
    formulaChanged();
  });
  packageEl.addEventListener('change', () => {
    state.packageTouched = true;
    customPackageWrap.hidden = packageEl.value !== 'custom';
    if(packageEl.value === 'custom'){
      customPackageUnitTouched = false;
      syncCustomPackageUnitToBatch();
    }
    formulaChanged();
  });
  finishedCountEl?.addEventListener('input', formulaChanged);
  mixtureDensityEl?.addEventListener('input', formulaChanged);
  confirmBasisEl?.addEventListener('click', () => {
    state.confirmedBasis = measurementBasis(currentBatchUnit());
    formulaChanged();
  });
  viewOrderBtn?.addEventListener('click', scrollToOrder);

  document.addEventListener('pointerdown', closeSuggestionsOutside);
  document.addEventListener('shopify:section:unload', handleSectionUnload);
  root.addEventListener('input', formulaDraftChanged);
  root.addEventListener('change', formulaDraftChanged);
  window.addEventListener('pagehide', saveFormulaDraft);
  setupMobileSummary();
  setupOrderVisibility();
  enforceBatchSizeLimit();
  updateTargetBatchButtonLabel();
  initializeFormula();

  async function initializeFormula(){
    const params = new URLSearchParams(window.location.search);
    // A new product link starts with its requested flavour and size. Switching
    // language on the same link still continues the visitor's edited formula.
    const linkedProduct = current || ['flavour', 'variant', 'variant_id', 'size'].some(key => params.get(key));
    if(restoreFormulaDraft(Boolean(linkedProduct))){
      draftDirty = true;
    }else{
      await initializeRowsFromUrl();
    }
    draftReady = true;
  }

  function formulaDraftChanged(){
    if(!draftReady) return;
    draftDirty = true;
    saveFormulaDraft();
  }

  function formulaLinkIdentity(){
    const params = new URLSearchParams(window.location.search);
    return JSON.stringify([current?.handle || '', sanitizeProductHandle(params.get('flavour')),
      params.get('variant') || params.get('variant_id') || '', params.get('size') || '']);
  }

  function saveFormulaDraft(){
    if(!draftReady || !draftDirty || state.rows.some(row => row.usageRejected) || !Number.isFinite(parseDecimal(batchSizeEl?.value))) return;
    try{
      // Store inputs and product identities only. Localized names, availability,
      // prices and calculated order quantities always come from the current page.
      window.sessionStorage.setItem(draftKey, JSON.stringify({
        version:1,
        locale:getShopifyRoot(), link:formulaLinkIdentity(),
        controls:Object.fromEntries(Object.entries(draftControls).map(([key, el]) => [key, el?.value ?? ''])),
        rows:state.rows.map(row => ({
          handle:row.product?.handle || '', usage:row.usage, densityOverride:row.densityOverride,
          purchaseVariantId:row.purchaseVariantId, purchasePlanKey:row.purchasePlanKey,
          purchaseSelectionTouched:row.purchaseSelectionTouched
        })),
        confirmedBasis:state.confirmedBasis, packageTouched:state.packageTouched, customPackageUnitTouched,
        testTarget:state.rows.findIndex(row => row.id === state.testBatch.targetRowId)
      }));
    }catch(e){ /* Storage may be unavailable; the calculator must still work. */ }
  }

  function restoreFormulaDraft(linkedProduct){
    let draft;
    try{ draft = JSON.parse(window.sessionStorage.getItem(draftKey)); }
    catch(e){ return false; }
    if(draft?.version !== 1 || !draft.controls || !Array.isArray(draft.rows) || !draft.rows.length || draft.rows.length > 100) return false;
    if(linkedProduct && (draft.link !== formulaLinkIdentity() || draft.locale === getShopifyRoot())) return false;
    if(draft.rows.some(row => !row || typeof row !== 'object' || !Number.isFinite(Number(row.usage)))) return false;
    // Preserve an edit made to the server-rendered controls before JS arrived.
    if(Object.values(draftControls).some(el => el && el.value !== (el.tagName === 'SELECT'
      ? ([...el.options].find(option => option.defaultSelected) || el.options[0])?.value
      : el.defaultValue))) return false;

    Object.entries(draftControls).forEach(([key, el]) => {
      const value = draft.controls[key];
      if(!el || typeof value !== 'string' || value.length > 32) return;
      if(el.tagName === 'SELECT'){
        if([...el.options].some(option => option.value === value)) el.value = value;
      }else if(value === '' || Number.isFinite(parseDecimal(value))){
        el.value = el.inputMode === 'decimal' ? formatDecimalInput(value) : value;
      }
    });
    state.confirmedBasis = ['volume', 'weight'].includes(draft.confirmedBasis) ? draft.confirmedBasis : null;
    state.packageTouched = draft.packageTouched === true;
    customPackageUnitTouched = draft.customPackageUnitTouched === true;
    let remainingUsage = MAX_TOTAL_USAGE_PERCENT;
    state.rows = draft.rows.map(saved => {
      const handle = sanitizeProductHandle(saved.handle);
      const product = handle ? normalizeProduct({
        ...(products.find(item => item.handle === handle) || { handle, title:handle.replace(/-/g, ' ') }), variants:[]
      }) : null;
      const usage = Math.min(remainingUsage, Math.max(0, Number(saved.usage)));
      remainingUsage -= usage;
      return {
        id:uid(), product, usage,
        densityOverride:typeof saved.densityOverride === 'string' && saved.densityOverride.length <= 32
          && (saved.densityOverride === '' || Number.isFinite(parseDecimal(saved.densityOverride))) ? saved.densityOverride : null,
        usageRejected:false, usageValidationMessage:'', productValidationMessage:'',
        purchaseVariantId:String(saved.purchaseVariantId || ''), purchasePlanKey:String(saved.purchasePlanKey || ''),
        purchaseSelectionTouched:saved.purchaseSelectionTouched === true
      };
    });
    state.testBatch = {
      targetRowId:state.rows[draft.testTarget]?.id || state.rows[0].id,
      size:testBatchSizeEl?.value || '', unit:testBatchUnitEl?.value || 'ml',
      flavourUsed:testBatchFlavourUsedEl?.value || '', flavourUnit:testBatchFlavourUnitEl?.value || 'ml', result:''
    };
    if(customPackageWrap) customPackageWrap.hidden = packageEl.value !== 'custom';
    if(targetCustomWrap) targetCustomWrap.hidden = targetPackageSizeEl.value !== 'custom';
    enforceBatchSizeLimit();
    renderRows();
    formulaChanged();
    state.rows.forEach(row => {
      if(!row.product) return;
      const pendingProduct = row.product;
      hydrateProduct(pendingProduct).then(product => {
        // A reset, removal or new selection made during the request wins.
        if(!state.rows.includes(row) || row.product !== pendingProduct) return;
        row.product = product;
        if(!product) row.productValidationMessage = wfT("Could not load this flavour’s prices and sizes. Select it again to retry.");
        renderRows();
        formulaChanged();
      });
    });
    return true;
  }

  async function initializeRowsFromUrl(){
    const params = new URLSearchParams(window.location.search);
    const requestedHandle = sanitizeProductHandle(params.get('flavour'));
    const requestedVariant = String(params.get('variant') || params.get('variant_id') || '').trim();
    const requestedSize = String(params.get('size') || '').trim();
    let product = current;
    let productLoadFailed = false;

    if(requestedHandle){
      product = products.find(item => String(item.handle || '').toLowerCase() === requestedHandle)
        || normalizeProduct({
          title:requestedHandle.split('-').filter(Boolean).map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' '),
          handle:requestedHandle,
          variants:[]
        });
      if(!product){
        addRow(null);
        setRowProductValidation(state.rows[0], wfT("Sample packs contain multiple flavours. Select an individual flavour to calculate usage and cost."));
        return;
      }
    }

    if(product && (requestedHandle || requestedVariant || requestedSize)){
      product = await hydrateProduct(product);
      productLoadFailed = !product;
      if(product && !products.some(item => item.handle === product.handle)) products.push(product);
    }

    addRow(product, resolveRequestedVariantId(product, requestedVariant, requestedSize));
    if(productLoadFailed){
      setRowProductValidation(state.rows[0], wfT("Could not load the linked flavour. Search for its name or SKU to try again."));
    }
  }

  function sanitizeProductHandle(value){
    const text = String(value || '').trim().toLowerCase();
    const productPath = text.includes('/products/') ? text.split('/products/').pop() : text;
    return String(productPath || '').split(/[/?#]/)[0].replace(/[^a-z0-9-]/g, '');
  }

  function resolveRequestedVariantId(product, variantValue, sizeValue){
    const variants = product?.variants || [];
    const requestedId = String(variantValue || '').trim();
    const requestedSize = normalizeVariantParam(sizeValue);

    if(requestedId){
      const idMatch = variants.find(variant => String(variant.id || '') === requestedId);
      if(idMatch) return String(idMatch.id);
    }

    if(requestedSize){
      const sizeMatch = variants.find(variant =>
        normalizeVariantParam(variant.title) === requestedSize ||
        normalizeVariantParam(variant.sku) === requestedSize ||
        String(variant.id || '') === String(sizeValue || '').trim()
      );
      if(sizeMatch) return String(sizeMatch.id);
    }

    return '';
  }

  function normalizeVariantParam(value){
    return normalizeSearch(value).replace(/[^a-z0-9.]+/g, '');
  }

  function addRow(preselect, purchaseVariantId){
    const focusFlavourAfterAdd = !preselect && state.rows.length > 0;
    const requestedVariantId = String(purchaseVariantId || '');
    const availableUsage = Math.max(0, MAX_TOTAL_USAGE_PERCENT - totalUsagePercent());
    if(!preselect && state.rows.length && availableUsage <= 0) return;
    const duplicateOwner = preselect ? selectedProductAssignment(preselect.handle) : null;
    const initialRow = !state.rows.length ? rowsEl.querySelector('[data-wf-initial-row]') : null;
    const initialUsage = initialRow ? parseDecimal(initialRow.querySelector('[data-usage]').value) : defaultUsage;
    const row = {
      id:initialRow?.dataset.rowId || uid(),
      product:duplicateOwner ? null : preselect,
      usage:Math.min(Math.max(0, Number.isFinite(initialUsage) ? initialUsage : defaultUsage), availableUsage),
      densityOverride:null,
      usageRejected:!Number.isFinite(initialUsage),
      usageValidationMessage:Number.isFinite(initialUsage) ? '' : wfT("Enter a valid number using a decimal comma or dot."),
      productValidationMessage:duplicateOwner ? wfT("Already selected as Flavour {0}.", [duplicateOwner.index + 1]) : '',
      purchaseVariantId:requestedVariantId,
      purchasePlanKey:'',
      purchaseSelectionTouched:Boolean(requestedVariantId)
    };
    state.rows.push(row);
    renderRows();
    formulaChanged();
    if(focusFlavourAfterAdd){
      window.requestAnimationFrame(() => root.querySelector(`[data-row-id="${row.id}"] [data-search-trigger]`)?.focus());
    }
  }

  function removeRow(id){
    state.rows = state.rows.filter(r => r.id !== id);
    renderRows();
    formulaChanged();
  }

  function clearRowProduct(id){
    const row = state.rows.find(item => item.id === id);
    if(!row?.product) return;
    row.product = null;
    row.densityOverride = null;
    row.purchaseVariantId = '';
    row.purchasePlanKey = '';
    row.purchaseSelectionTouched = false;
    row.productValidationMessage = '';
    renderRows();
    formulaChanged();
    window.requestAnimationFrame(() => root.querySelector(`[data-row-id="${id}"] [data-search-trigger]`)?.focus());
  }

  function selectedProductAssignment(handle, excludingRowId){
    const normalizedHandle = String(handle || '').trim().toLowerCase();
    if(!normalizedHandle) return null;
    const index = state.rows.findIndex(row =>
      row.id !== excludingRowId && String(row.product?.handle || '').trim().toLowerCase() === normalizedHandle
    );
    return index < 0 ? null : { row:state.rows[index], index };
  }

  function duplicateProductHandles(rows = state.rows){
    const seen = new Set();
    const duplicates = new Set();
    rows.forEach(row => {
      const handle = String(row.product?.handle || '').trim().toLowerCase();
      if(!handle) return;
      if(seen.has(handle)) duplicates.add(handle);
      seen.add(handle);
    });
    return duplicates;
  }

  function syncProductValidationMessages(duplicates = duplicateProductHandles()){
    state.rows.forEach((row, rowIndex) => {
      const handle = String(row.product?.handle || '').trim().toLowerCase();
      if(handle && duplicates.has(handle)){
        const firstIndex = state.rows.findIndex(item => String(item.product?.handle || '').trim().toLowerCase() === handle);
        row.productValidationMessage = firstIndex === rowIndex
          ? wfT("This product is selected more than once. Keep it in only one flavour row.")
          : wfT("Already selected as Flavour {0}.", [firstIndex + 1]);
      }else if(row.productValidationMessage?.startsWith(wfT("This product is selected more than once")) || row.productValidationMessage?.startsWith(wfT("Already selected as Flavour"))){
        row.productValidationMessage = '';
      }
      const rowEl = rowsEl.querySelector(`[data-row-id="${row.id}"]`);
      const errorEl = rowEl?.querySelector('[data-row-product-error]');
      if(errorEl){
        errorEl.hidden = !row.productValidationMessage;
        errorEl.textContent = row.productValidationMessage;
      }
    });
  }

  function resetCalculator(){
    const selectedCount = state.rows.filter(row => row.product).length;
    const losesSeveralEntries = selectedCount > 1 || state.rows.length > 2;
    if(losesSeveralEntries && !window.confirm(wfT("Reset this formula and clear all selected flavours?"))) return;

    root.querySelectorAll('[data-suggestions]').forEach(closeSuggestions);
    if(batchSizeEl) batchSizeEl.value = numForBatchInput(defaultBatchSize);
    if(batchUnitEl) batchUnitEl.value = 'L';
    state.confirmedBasis = 'volume';
    state.packageTouched = false;
    if(finishedCountEl) finishedCountEl.value = '';
    if(mixtureDensityEl) mixtureDensityEl.value = '';
    if(targetYieldEl) targetYieldEl.value = '100';
    if(packageEl) packageEl.value = '0.355';
    if(customPackageEl) customPackageEl.value = '355';
    if(customPackageUnitEl) customPackageUnitEl.value = 'ml';
    if(customPackageWrap) customPackageWrap.hidden = true;
    customPackageUnitTouched = false;
    if(targetPackagesEl) targetPackagesEl.value = '1000';
    if(targetPackageSizeEl) targetPackageSizeEl.value = '0.355';
    if(targetCustomPackageEl) targetCustomPackageEl.value = '355';
    if(targetCustomUnitEl) targetCustomUnitEl.value = 'ml';
    if(targetCustomWrap) targetCustomWrap.hidden = true;
    if(targetResultEl) targetResultEl.textContent = '';
    state.testBatch = { targetRowId:'', size:250, unit:'ml', flavourUsed:0.5, flavourUnit:'ml', result:'' };
    [toolsEl, testBatchPanelEl, batchBuilderEl, packageSettingsEl, calculationDetailsEl].forEach(detailsEl => {
      if(detailsEl) detailsEl.open = false;
    });
    state.rows = [];
    enforceBatchSizeLimit();
    updateTargetBatchButtonLabel();
    addRow(null);
    draftDirty = false;
    try{ window.sessionStorage.removeItem(draftKey); }catch(e){ /* Storage is optional. */ }
    window.requestAnimationFrame(() => batchSizeEl?.focus());
  }

  function formulaChanged(){
    setCartStatus('');
    calculate();
    toggleAddAnotherButton();
    formulaDraftChanged();
  }

  function usageTotalExcluding(rowId){
    return state.rows.reduce((sum, row) => row.id === rowId
      ? sum
      : sum + Math.max(0, Number(row.usage) || 0), 0);
  }

  function totalUsagePercent(){
    const total = state.rows.reduce((sum, row) => sum + Math.max(0, Number(row.usage) || 0), 0);
    return Math.round((total + Number.EPSILON) * 1000) / 1000;
  }

  function maximumUsageForRow(rowId){
    const remaining = MAX_TOTAL_USAGE_PERCENT - usageTotalExcluding(rowId);
    return Math.max(0, Math.round((remaining + Number.EPSILON) * 1000) / 1000);
  }

  function usageLimitMessage(maximum){
    return wfT("Maximum: {0}.", [formatPercent(maximum)]);
  }

  function syncUsageConstraints(preserveMessageRowId){
    state.rows.forEach(row => {
      const maximum = maximumUsageForRow(row.id);
      const rowEl = rowsEl.querySelector(`[data-row-id="${row.id}"]`);
      const usageInput = rowEl?.querySelector('[data-usage]');
      const usageError = rowEl?.querySelector('[data-row-usage-error]');
      if(usageInput) usageInput.max = String(maximum);
      if(row.id !== preserveMessageRowId && !row.usageRejected){
        row.usageValidationMessage = '';
      }
      if(usageError){
        usageError.hidden = !row.usageValidationMessage;
        usageError.textContent = row.usageValidationMessage;
      }
    });
  }

  function maximumBatchInputForUnit(unit){
    return isWeightUnit(unit) ? weightFromKg(MAX_BATCH_LITRES, unit) : volumeFromLitres(MAX_BATCH_LITRES, unit);
  }

  function handleBatchUnitChange(){
    // Keep the entered number. Crossing weight/volume needs an explicit rate confirmation.
    enforceBatchSizeLimit();
    if(!state.packageTouched) packageEl.value = isWeightUnit(currentBatchUnit()) ? 'w100' : '0.355';
    if(packageEl?.value === 'custom' && !customPackageUnitTouched) syncCustomPackageUnitToBatch();
    formulaChanged();
  }

  function enforceBatchSizeLimit(){
    if(!batchSizeEl) return;
    const unit = batchUnitEl?.value || 'L';
    const maximum = maximumBatchInputForUnit(unit);
    batchSizeEl.max = String(maximum);
    const rawValue = String(batchSizeEl.value || '').trim();
    const enteredValue = parseDecimal(rawValue);
    const exceedsMaximum = rawValue !== '' && Number.isFinite(enteredValue) && enteredValue > maximum;
    if(exceedsMaximum) batchSizeEl.value = numForBatchInput(maximum);
    const invalid = !Number.isFinite(enteredValue);
    batchSizeEl.setAttribute('aria-invalid', String(invalid));
    if(batchErrorEl){
      batchErrorEl.hidden = !exceedsMaximum && !invalid;
      batchErrorEl.textContent = invalid ? wfT("Enter a valid number using a decimal comma or dot.") : exceedsMaximum
        ? wfT("Maximum batch size: {0}.", [formatVolumeAmount(maximum, unit)])
        : '';
    }
  }

  function renderRows(){
    const initialRow = rowsEl.querySelector('[data-wf-initial-row]');
    const reuseInitialRow = initialRow && state.rows.length === 1 &&
      !state.rows[0].product && state.rows[0].id === initialRow.dataset.rowId;
    if(!reuseInitialRow) rowsEl.replaceChildren();
    if(!state.rows.length){ addRow(null); return; }
    state.rows.forEach((row, rowIndex) => {
      const canRemove = state.rows.length > 1;
      const canClearProduct = !canRemove && Boolean(row.product);
      const hasRowAction = canRemove || canClearProduct;
      const suggestionsId = `${root.id}-${row.id}-suggestions`;
      const flavourFieldLabelId = `${root.id}-${row.id}-flavour-label`;
      const productErrorId = `${root.id}-${row.id}-product-error`;
      const usageInputId = `${root.id}-${row.id}-usage`;
      const usageErrorId = `${root.id}-${row.id}-usage-error`;
      const genericFlavourName = wfT("Flavour {0}", [rowIndex + 1]);
      const rowName = displayTitle(row.product) || genericFlavourName;
      const el = reuseInitialRow ? initialRow : document.createElement('div');
      el.className = `wfcalc2__row${state.rows.length === 1 ? ' wfcalc2__row--single' : ''}${hasRowAction ? ' wfcalc2__row--action' : ''}`;
      el.dataset.rowId = row.id;
      if(!reuseInitialRow) el.innerHTML = `
        <div class="wfcalc2__search-wrap">
          <span id="${flavourFieldLabelId}" class="wfcalc2__field-label wfcalc2__row-field-label">${wfH('Flavour')}${!row.product && state.rows.length === 1 ? ` <small>${wfH('Optional')}</small>` : ''}</span>
          <div class="wfcalc2__search-input${row.product ? ' wfcalc2__search-input--with-image' : ''}">
            ${productThumbnail(row.product)}
            <button type="button" class="button-unstyled wfcalc2__flavour-trigger" data-search-trigger aria-label="${wfH("Select a flavour product for {0}", [genericFlavourName])}" aria-describedby="${productErrorId}" aria-haspopup="listbox" aria-expanded="false" aria-controls="${suggestionsId}" ${row.product ? 'hidden' : ''}>
              <span>${wfH("Select a flavour")}</span>
              <span class="wfcalc2__search-icon" aria-hidden="true"></span>
            </button>
            <input type="search" value="${escapeHtml(displayTitle(row.product))}" title="${escapeAttr(displayTitle(row.product))}" placeholder="${wfH("Type strawberry, mango, SC-123…")}" data-search autocomplete="off" role="combobox" aria-label="${wfH("Search for a flavour product for {0}", [genericFlavourName])}" aria-describedby="${productErrorId}" aria-autocomplete="list" aria-haspopup="listbox" aria-expanded="false" aria-controls="${suggestionsId}" ${row.product ? '' : 'hidden'}>
          </div>
          <div id="${suggestionsId}" class="wfcalc2__suggestions" data-suggestions role="listbox" hidden></div>
          <p id="${productErrorId}" class="wfcalc2__validation-message" data-row-product-error role="status" ${row.productValidationMessage ? '' : 'hidden'}>${escapeHtml(row.productValidationMessage)}</p>
        </div>
        <div class="wfcalc2__usage-cell">
          <label class="wfcalc2__usage-label wfcalc2__row-field-label" for="${usageInputId}">${wfH("Usage (%)")}<small data-row-basis></small></label>
          <input id="${usageInputId}" type="text" min="0" max="${maximumUsageForRow(row.id)}" step="0.01" inputmode="decimal" value="${formatDecimalInput(row.usage)}" data-usage aria-label="${wfH("Usage rate for {0} (%)", [rowName])}" aria-describedby="${usageErrorId}">
          <p id="${usageErrorId}" class="wfcalc2__validation-message" data-row-usage-error role="status" ${row.usageValidationMessage ? '' : 'hidden'}>${escapeHtml(row.usageValidationMessage)}</p>
        </div>
        <div class="wfcalc2__required-cell">
          <span class="wfcalc2__field-label wfcalc2__row-field-label">${wfH("Required")}</span>
          <output class="wfcalc2__required-output" data-row-required aria-label="${wfH("Required flavour amount for {0}", [rowName])}"></output>
        </div>
        <details class="wfcalc2__density-field" data-row-density-wrap hidden>
          <summary class="wfcalc2__disclosure-summary">
            <span data-row-density-summary>${wfH('Flavour density')}</span>
            <span class="wfcalc2__disclosure-chevron" aria-hidden="true"></span>
          </summary>
          <label for="${root.id}-${row.id}-density">
            <span class="wfcalc2__field-label">${wfH("Flavour density (g/mL)")}</span>
            <input id="${root.id}-${row.id}-density" type="text" min="0.001" step="any" inputmode="decimal" data-row-density aria-label="${wfH("Flavour density for {0} in grams per millilitre", [rowName])}" aria-describedby="${root.id}-${row.id}-density-help" placeholder="${wfH("Enter density")}">
          </label>
          <small id="${root.id}-${row.id}-density-help" class="wfcalc2__field-help" data-row-density-help></small>
        </details>
        ${hasRowAction ? `<div class="wfcalc2__remove-cell">
          <button type="button" class="button-unstyled wfcalc2__remove" aria-label="${canRemove ? wfH("Remove {0}", [rowName]) : wfH("Clear selected {0}", [rowName])}" ${canRemove ? 'data-remove' : 'data-clear-product'}>×</button>
        </div>` : ''}`;
      el.removeAttribute('data-wf-initial-row');
      if(!reuseInitialRow) rowsEl.appendChild(el);

      const search = el.querySelector('[data-search]');
      const searchTrigger = el.querySelector('[data-search-trigger]');
      const suggestions = el.querySelector('[data-suggestions]');
      const usage = el.querySelector('[data-usage]');
      if(reuseInitialRow) usage.value = numForInput(row.usage);
      const usageError = el.querySelector('[data-row-usage-error]');
      el.querySelector('[data-row-density]')?.addEventListener('input', event => {
        row.densityOverride = event.target.value;
        formulaChanged();
      });

      const debouncedSearch = debounce(() => showSuggestions(search.value, suggestions, row), 160);
      searchTrigger.addEventListener('click', () => {
        row.productValidationMessage = '';
        searchTrigger.hidden = true;
        search.hidden = false;
        search.value = '';
        searchTrigger.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(() => search.focus());
      });
      search.addEventListener('input', () => {
        // Invalidate pending searches and selections before the debounce expires.
        row.searchToken = (row.searchToken || 0) + 1;
        row.selectionToken = (row.selectionToken || 0) + 1;
        if(row.product && normalizeSearch(search.value) !== normalizeSearch(displayTitle(row.product))){
          row.product = null;
    row.densityOverride = null;
          row.purchaseVariantId = '';
          row.purchasePlanKey = '';
          row.purchaseSelectionTouched = false;
          row.productValidationMessage = '';
          const searchInput = search.closest('.wfcalc2__search-input');
          searchInput?.classList.remove('wfcalc2__search-input--with-image');
          searchInput?.querySelector('.wfcalc2__thumb')?.remove();
          formulaChanged();
          toggleAddAnotherButton();
          syncTestBatchTargets();
        }
        debouncedSearch();
      });
      search.addEventListener('focus', () => {
        if(search.dataset.suppressSuggestions === 'true') return;
        showSuggestions(search.value, suggestions, row);
      });
      search.addEventListener('keydown', async event => {
        if(event.key === 'Escape'){
          closeSuggestions(suggestions);
          if(!row.product){
            restoreGenericFlavourTrigger(el, true);
          }
        }
        if(event.key === 'ArrowDown' || event.key === 'ArrowUp'){
          event.preventDefault();
          if(suggestions.hidden) await showSuggestions(search.value, suggestions, row);
          const options = suggestionOptions(suggestions);
          const option = event.key === 'ArrowDown' ? options[0] : options[options.length - 1];
          option?.focus();
        }
      });
      usage.addEventListener('input', () => {
        const maximum = maximumUsageForRow(row.id);
        const rawUsage = String(usage.value || '').trim();
        const numericUsage = parseDecimal(rawUsage);
        const enteredUsage = Number.isFinite(numericUsage) ? numericUsage : 0;
        const exceedsAvailableUsage = enteredUsage > maximum;
        const belowMinimum = enteredUsage < 0;
        row.usage = Math.min(maximum, Math.max(0, enteredUsage));
        row.usageRejected = !Number.isFinite(numericUsage);
        usage.setAttribute('aria-invalid', String(row.usageRejected));
        row.usageValidationMessage = row.usageRejected ? wfT("Enter a valid number using a decimal comma or dot.") : exceedsAvailableUsage
          ? usageLimitMessage(maximum)
          : (belowMinimum ? wfT("Minimum usage: 0%.") : '');
        if(exceedsAvailableUsage || belowMinimum) usage.value = numForInput(row.usage);
        if(usageError){
          usageError.hidden = !row.usageValidationMessage;
          usageError.textContent = row.usageValidationMessage;
        }
        syncUsageConstraints(row.id);
        formulaChanged();
      });
      el.querySelector('[data-remove]')?.addEventListener('click', () => removeRow(row.id));
      el.querySelector('[data-clear-product]')?.addEventListener('click', () => clearRowProduct(row.id));
    });
    syncUsageConstraints();
    syncProductValidationMessages();
    toggleAddAnotherButton();
    syncTestBatchTargets();
    syncSearchOpenState();
  }

  function closeSuggestionsOutside(event){
    root.querySelectorAll('[data-suggestions]').forEach(box => {
      const searchWrap = box.closest('.wfcalc2__search-wrap');
      if(!searchWrap || !searchWrap.contains(event.target)){
        closeSuggestions(box);
        restoreGenericFlavourTrigger(searchWrap);
      }
    });
  }

  function restoreGenericFlavourTrigger(searchWrap, restoreFocus){
    if(!searchWrap) return;
    const rowId = searchWrap.closest('[data-row-id]')?.dataset.rowId;
    const row = state.rows.find(item => item.id === rowId);
    if(!row || row.product) return;
    const search = searchWrap.querySelector('[data-search]');
    const trigger = searchWrap.querySelector('[data-search-trigger]');
    if(search){
      search.value = '';
      search.hidden = true;
    }
    if(trigger){
      trigger.hidden = false;
      trigger.setAttribute('aria-expanded', 'false');
      if(restoreFocus) trigger.focus();
    }
  }

  function handleSectionUnload(event){
    if(event.target?.contains(root) || !document.documentElement.contains(root)){
      document.removeEventListener('pointerdown', closeSuggestionsOutside);
      document.removeEventListener('shopify:section:unload', handleSectionUnload);
      root.removeEventListener('input', formulaDraftChanged);
      root.removeEventListener('change', formulaDraftChanged);
      window.removeEventListener('pagehide', saveFormulaDraft);
      window.removeEventListener('resize', updateMobileSummaryLayout);
      window.visualViewport?.removeEventListener('resize', updateMobileSummaryLayout);
      window.visualViewport?.removeEventListener('scroll', updateOpenSuggestionPositions);
      orderVisibilityObserver?.disconnect();
      calculatorVisibilityObserver?.disconnect();
      mobileSummaryResizeObserver?.disconnect();
      if(mobileSummaryFrame) cancelAnimationFrame(mobileSummaryFrame);
      [document.documentElement, document.body].forEach(scrollRoot => {
        scrollRoot?.classList.remove('wfcalc2-has-mobile-summary');
        scrollRoot?.style.removeProperty('--wfcalc-mobile-summary-reserve');
      });
      mobileSummaryPortal?.remove();
      mobileSummarySpacer?.remove();
      window.requestAnimationFrame(() => {
        if(!document.querySelector(CALCULATOR_SELECTOR)) document.documentElement.classList.remove('wfcalc2-page');
      });
    }
  }

  function setupMobileSummary(){
    if(mobileSummaryEl && document.body){
      mobileSummaryPortal = document.createElement('div');
      mobileSummaryPortal.className = 'wfcalc2 wfcalc2__portal';
      mobileSummaryPortal.appendChild(mobileSummaryEl);
      document.body.appendChild(mobileSummaryPortal);
      mobileSummarySpacer = document.createElement('div');
      mobileSummarySpacer.className = 'wfcalc2__mobile-summary-spacer';
      mobileSummarySpacer.setAttribute('aria-hidden', 'true');
      document.body.appendChild(mobileSummarySpacer);
    }
    updateMobileSummaryLayout();
    window.addEventListener('resize', updateMobileSummaryLayout, { passive:true });
    window.visualViewport?.addEventListener('resize', updateMobileSummaryLayout, { passive:true });
    window.visualViewport?.addEventListener('scroll', updateOpenSuggestionPositions, { passive:true });
    if(window.ResizeObserver && mobileSummaryEl){
      mobileSummaryResizeObserver = new ResizeObserver(queueMobileSummaryReserve);
      mobileSummaryResizeObserver.observe(mobileSummaryEl);
    }
  }

  function updateMobileSummaryLayout(){
    mobileSummaryPortal?.style.setProperty('--wf-mobile-summary-right', '12px');
    mobileSummaryPortal?.style.setProperty('--wf-mobile-summary-bottom', '12px');
    updateOpenSuggestionPositions();
    queueMobileSummaryReserve();
  }

  function queueMobileSummaryReserve(){
    if(mobileSummaryFrame) cancelAnimationFrame(mobileSummaryFrame);
    mobileSummaryFrame = requestAnimationFrame(() => {
      mobileSummaryFrame = 0;
      const searchOpen = mobileSummaryEl?.dataset.searchOpen === 'true';
      const summaryActive = window.matchMedia('(max-width: 760px)').matches &&
        mobileSummaryEl?.dataset.ready === 'true' &&
        mobileSummaryEl?.dataset.estimateVisible !== 'true' &&
        mobileSummaryEl?.dataset.calculatorActive !== 'false' &&
        !searchOpen;
      const summaryHeight = summaryActive ? (mobileSummaryEl?.getBoundingClientRect().height || 0) : 0;
      const reserve = summaryActive ? Math.ceil(summaryHeight + 24) : 0;
      [document.documentElement, document.body].forEach(scrollRoot => {
        scrollRoot?.style.setProperty('--wfcalc-mobile-summary-reserve', `${reserve}px`);
        scrollRoot?.classList.toggle('wfcalc2-has-mobile-summary', Boolean(summaryActive));
      });
      if(mobileSummarySpacer){
        mobileSummarySpacer.style.setProperty('--wfcalc-mobile-summary-reserve', `${reserve}px`);
      }
    });
  }

  function setupOrderVisibility(){
    if(!mobileSummaryEl || !window.IntersectionObserver) return;
    const summaryStopTargets = [resultEl, purchaseEl].filter(Boolean);
    if(summaryStopTargets.length){
      const visibleSummaryTargets = new Set();
      orderVisibilityObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if(entry.isIntersecting) visibleSummaryTargets.add(entry.target);
          else visibleSummaryTargets.delete(entry.target);
        });
        mobileSummaryEl.dataset.estimateVisible = visibleSummaryTargets.size ? 'true' : 'false';
        queueMobileSummaryReserve();
      }, { threshold:0.01, rootMargin:'0px 0px -8% 0px' });
      summaryStopTargets.forEach(target => orderVisibilityObserver.observe(target));
    }
    calculatorVisibilityObserver = new IntersectionObserver(entries => {
      const calculatorIsVisible = entries.some(entry => entry.isIntersecting);
      mobileSummaryEl.dataset.calculatorActive = calculatorIsVisible ? 'true' : 'false';
      queueMobileSummaryReserve();
    }, { threshold:0 });
    calculatorVisibilityObserver.observe(root);
  }

  function syncCustomPackageUnitToBatch(){
    if(!customPackageUnitEl) return;
    const unit = currentBatchUnit();
    customPackageUnitEl.value = isWeightUnit(unit) ? (unit === 'lb' || unit === 'oz' ? 'oz' : 'g')
      : (['gal_us','fl_oz','bbl_us'].includes(unit) ? 'fl_oz' : (unit === 'ml' ? 'ml' : 'L'));
  }

  function scrollToOrder(){
    const missingRow = state.rows.find(row => !row.product);
    const missingRowEl = missingRow ? root.querySelector(`[data-row-id="${missingRow.id}"]`) : null;
    const missingProductControl = missingRowEl?.querySelector('[data-search-trigger]:not([hidden]), [data-search]:not([hidden])');
    const target = missingProductControl || (purchaseEl && !purchaseEl.hidden ? purchaseEl : resultEl);
    target?.scrollIntoView({ behavior:'smooth', block:'start' });
    if(target?.matches?.('[data-search-trigger]')){
      window.setTimeout(() => target.click(), 350);
    }else if(target?.matches?.('[data-search]')){
      window.setTimeout(() => target.focus({ preventScroll:true }), 350);
    }
  }

  function syncMobileAction(){
    if(!viewOrderBtn) return;
    viewOrderBtn.textContent = mobileActionLabel(state.rows);
  }

  function mobileActionLabel(rows){
    const missingProductCount = rows.filter(row => !row.product).length;
    return missingProductCount === rows.length
      ? wfT("Select a flavour")
      : (missingProductCount > 0 ? wfT("Select remaining") : wfT("Review order"));
  }

  function closeSuggestions(box){
    if(!box) return;
    box.dataset.open = 'false';
    box.hidden = true;
    box.removeAttribute('data-open-direction');
    box.style.removeProperty('max-height');
    box.closest('.wfcalc2__search-wrap')?.querySelector('[data-search]')?.setAttribute('aria-expanded', 'false');
    box.closest('.wfcalc2__search-wrap')?.querySelector('[data-search-trigger]')?.setAttribute('aria-expanded', 'false');
    syncSearchOpenState();
  }

  function syncSearchOpenState(){
    const searchOpen = [...root.querySelectorAll('[data-suggestions]')].some(box => !box.hidden && box.dataset.open !== 'false');
    if(mobileSummaryEl) mobileSummaryEl.dataset.searchOpen = searchOpen ? 'true' : 'false';
    queueMobileSummaryReserve();
  }

  function positionSuggestions(box){
    if(!box || box.hidden) return;
    const anchor = box.closest('.wfcalc2__search-wrap')?.querySelector('.wfcalc2__search-input');
    if(!anchor) return;
    const anchorRect = anchor.getBoundingClientRect();
    const viewport = window.visualViewport;
    const viewportTop = viewport?.offsetTop || 0;
    const viewportHeight = viewport?.height || window.innerHeight;
    const viewportBottom = viewportTop + viewportHeight;
    const below = Math.max(0, viewportBottom - anchorRect.bottom - 12);
    const above = Math.max(0, anchorRect.top - viewportTop - 12);
    const openUp = below < 180 && above > below;
    const available = openUp ? above : below;
    box.dataset.openDirection = openUp ? 'up' : 'down';
    box.style.maxHeight = `${Math.max(44, Math.min(260, Math.floor(available)))}px`;
  }

  function updateOpenSuggestionPositions(){
    root.querySelectorAll('[data-suggestions]').forEach(box => {
      if(!box.hidden) positionSuggestions(box);
    });
  }

  function toggleAddAnotherButton(){
    if(!addRowBtn) return;
    addRowBtn.hidden = false;
    const totalUsage = totalUsagePercent();
    const maximumReached = totalUsage >= MAX_TOTAL_USAGE_PERCENT;
    addRowBtn.disabled = maximumReached;
    addRowBtn.title = maximumReached ? wfT("Reduce total usage below 100% to add another flavour.") : '';
    if(addRowStatusEl){
      addRowStatusEl.hidden = !maximumReached;
      addRowStatusEl.textContent = maximumReached
        ? wfT("Total flavour usage has reached 100%. Reduce a usage rate to add another flavour.")
        : '';
    }
  }

  function testBatchTargetName(row, rowIndex){
    return displayTitle(row?.product) || wfT("Flavour {0} — not selected", [rowIndex + 1]);
  }

  function syncTestBatchTargets(){
    if(!testBatchTargetEl) return;
    const currentTargetExists = state.rows.some(row => row.id === state.testBatch.targetRowId);
    if(!currentTargetExists) state.testBatch.targetRowId = state.rows[0]?.id || '';
    testBatchTargetEl.innerHTML = state.rows.map((row, rowIndex) =>
      `<option value="${escapeAttr(row.id)}">${escapeHtml(testBatchTargetName(row, rowIndex))}</option>`
    ).join('');
    testBatchTargetEl.value = state.testBatch.targetRowId;
    syncTestBatchControlValues();
    updateTestBatchButtonLabel();
  }

  function syncTestBatchControlValues(){
    if(testBatchSizeEl) testBatchSizeEl.value = formatDecimalInput(state.testBatch.size);
    if(testBatchUnitEl) testBatchUnitEl.value = state.testBatch.unit || 'ml';
    if(testBatchFlavourUsedEl) testBatchFlavourUsedEl.value = formatDecimalInput(state.testBatch.flavourUsed);
    if(testBatchFlavourUnitEl) testBatchFlavourUnitEl.value = state.testBatch.flavourUnit || 'ml';
    setTestBatchResult(state.testBatch.result);
  }

  function updateTestBatchButtonLabel(){
    if(!testBatchApplyEl) return;
    const calculation = testBatchCalculation();
    const valid = !calculation.error;
    const roundedUsage = calculation.roundedUsage;
    testBatchApplyEl.textContent = valid ? wfT("Apply {0}", [formatPercent(roundedUsage)]) : wfT("Apply usage");
    testBatchApplyEl.disabled = !valid;
  }

  function setTestBatchResult(message){
    state.testBatch.result = message || '';
    if(!testBatchResultEl) return;
    testBatchResultEl.textContent = state.testBatch.result;
    testBatchResultEl.hidden = !state.testBatch.result;
  }

  function testBatchUnitLabel(unit){
    return unitLabel(unit);
  }

  function formatEnteredMeasurement(value, unit){
    const raw = String(value ?? '').trim();
    if(!raw) return '';
    const numeric = parseDecimal(raw);
    if(!Number.isFinite(numeric)) return '';
    return `${formatNumber(numeric, Math.min(6, Math.max(0, (raw.replace(',', '.').split('.')[1] || '').length)))} ${testBatchUnitLabel(unit)}`;
  }

  function updateTestBatchResultPreview(){
    syncMeasurementControls(measurementBasis(currentBatchUnit()), state.confirmedBasis !== measurementBasis(currentBatchUnit()));
    updateTestBatchButtonLabel();
    const calculation = testBatchCalculation();
    if(calculation.error){
      setTestBatchResult(calculation.error);
      return null;
    }
    const batchDisplay = formatEnteredMeasurement(state.testBatch.size, state.testBatch.unit);
    const flavourDisplay = formatEnteredMeasurement(state.testBatch.flavourUsed, state.testBatch.flavourUnit);
    setTestBatchResult(wfT("Using {0} in {1} equals {2} by {3}.{4}", [flavourDisplay, batchDisplay, formatPercent(calculation.roundedUsage), calculation.basis, calculation.estimated ? ' Flavour conversion uses estimated density.' : '']));
    return calculation;
  }

  function testBatchCalculation(){
    const t = state.testBatch;
    const row = state.rows.find(item => item.id === t.targetRowId);
    const basis = measurementBasis(t.unit);
    if(!row) return { error:wfT("Choose a flavour row to update.") };
    if(String(t.size).trim() === '' || String(t.flavourUsed).trim() === '' || !(parseDecimal(t.size) > 0) || !(parseDecimal(t.flavourUsed) >= 0)) return { error:wfT("Enter a positive test batch size and the flavour used.") };
    if(basis !== measurementBasis(currentBatchUnit())) return { error:wfT("Choose {0} for Batch size to apply this {1} based rate.", [basis === 'weight' ? 'kg, lb, g or oz' : 'volume units', basis]) };
    const density = flavourDensity(row);
    const batch = measurementToBase(parseDecimal(t.size), t.unit);
    const flavour = convertMeasurement(parseDecimal(t.flavourUsed), t.flavourUnit, basis, density.value);
    if(flavour === null) return { error:wfT("Enter the flavour density to convert the test measurement between weight and volume.") };
    const scaledUsage = flavour / batch * 100;
    if(!Number.isFinite(scaledUsage) || scaledUsage < 0 || scaledUsage > maximumUsageForRow(row.id)) return { error:usageLimitMessage(maximumUsageForRow(row.id)) };
    return { scaledUsage, roundedUsage:Math.round((scaledUsage + Number.EPSILON) * 1000) / 1000, basis,
      estimated:measurementBasis(t.flavourUnit) !== basis && density.estimated };
  }

  function targetBatchCalculation(){
    const measurement = packageMeasurement(targetPackageSizeEl, targetCustomPackageEl, targetCustomUnitEl);
    const count = parseDecimal(targetPackagesEl?.value);
    const yieldPercent = parseDecimal(targetYieldEl?.value);
    const batchBase = measurement.base * count / (yieldPercent / 100);
    const useImperial = measurement.unit === 'fl_oz' || measurement.unit === 'gal_us' || measurement.unit === 'lb' || measurement.unit === 'oz';
    const targetUnit = measurement.basis === 'weight' ? (useImperial ? 'lb' : 'kg') : (useImperial ? 'gal_us' : 'L');
    const valid = measurement.base > 0 && Number.isInteger(count) && count > 0 && yieldPercent > 0 && Number.isFinite(batchBase) && batchBase <= MAX_BATCH_LITRES;
    return { measurement, count, yieldPercent, batchBase, targetUnit, useImperial, valid };
  }

  function updateTargetBatchButtonLabel(){
    if(!targetApplyButton) return;
    const calculation = targetBatchCalculation();
    const { valid, batchBase, targetUnit } = calculation;
    targetApplyButton.disabled = !valid;
    const amount = isWeightUnit(targetUnit) ? weightFromKg(batchBase, targetUnit) : volumeFromLitres(batchBase, targetUnit);
    targetApplyButton.textContent = valid ? wfT("Use {0} batch", [formatVolumeAmount(amount, targetUnit)]) : wfT("Use batch size");
    if(targetResultEl) targetResultEl.textContent = valid ? '' : wfT("Enter a positive package size, whole package count and yield within the batch limit.");
  }

  function applyTestBatchMeasurements(){
    const targetRow = state.rows.find(row => row.id === state.testBatch.targetRowId) || state.rows[0];
    if(!targetRow) return;
    const testBatch = state.testBatch;
    const rowEl = root.querySelector(`[data-row-id="${targetRow.id}"]`);
    const usageInput = rowEl?.querySelector('[data-usage]');
    const usageError = rowEl?.querySelector('[data-row-usage-error]');
    const preview = updateTestBatchResultPreview();
    if(!preview) return;
    const { scaledUsage, roundedUsage } = preview;
    if(state.rows.length === 1) state.confirmedBasis = preview.basis;
    const maximum = maximumUsageForRow(targetRow.id);
    const exceedsAvailableUsage = scaledUsage > maximum;
    targetRow.usage = Math.min(maximum, roundedUsage);
    targetRow.usageRejected = false;
    targetRow.usageValidationMessage = exceedsAvailableUsage
      ? usageLimitMessage(maximum)
      : '';
    if(usageInput) usageInput.value = formatDecimalInput(targetRow.usage);
    if(usageError){
      usageError.hidden = !targetRow.usageValidationMessage;
      usageError.textContent = targetRow.usageValidationMessage;
    }
    syncUsageConstraints(targetRow.id);
    formulaChanged();
    if(exceedsAvailableUsage) setTestBatchResult(usageLimitMessage(maximum));
  }

  async function showSuggestions(q, box, row){
    box.dataset.open = 'true';
    const query = normalizeSearch(q);
    const searchToken = (row.searchToken || 0) + 1;
    row.searchToken = searchToken;
    let matches = products.filter(p => !query || matchesQuery(p, query)).slice(0, 18);
    let searchFailed = false;

    if(query.length >= 2 && matches.length < 6){
      const remote = await predictiveSearch(query);
      if(row.searchToken !== searchToken || box.dataset.open === 'false') return;
      searchFailed = remote === null;
      (remote || []).forEach(p => { if(!products.find(x => x.handle === p.handle)) products.push(p); });
      matches = dedupeProducts([...matches, ...(remote || [])]).filter(p => !query || matchesQuery(p, query)).slice(0,18);
    }
    setRowProductValidation(row, searchFailed
      ? wfT("Search could not finish. Results may be incomplete. Try your search again.")
      : '');

    if(!matches.length){
      box.setAttribute('role', 'status');
      box.innerHTML = query.length < 2
        ? '<div class="wfcalc2__suggestion-empty"><strong>' + wfH("Keep typing") + '</strong>' + wfH("Enter 2+ letters.") + '</div>'
        : searchFailed
          ? '<div class="wfcalc2__suggestion-empty"><strong>' + wfH("Search unavailable") + '</strong>' + wfH("Try your search again.") + '</div>'
          : '<div class="wfcalc2__suggestion-empty"><strong>' + wfH("No matching flavours") + '</strong>' + wfH("Try a shorter name or SKU.") + '</div>';
    } else {
      box.setAttribute('role', 'listbox');
      box.innerHTML = matches.map((p, optionIndex) => {
        const assignment = selectedProductAssignment(p.handle);
        const isSelected = Boolean(assignment);
        const isCurrentSelection = assignment?.row.id === row.id;
        const selectedState = assignment
          ? (assignment.row.id === row.id
            ? wfT("Selected as Flavour {0}", [assignment.index + 1])
            : wfT("Already selected as Flavour {0}", [assignment.index + 1]))
          : '';
        return `<button id="${escapeAttr(`${box.id}-option-${optionIndex}`)}" type="button" role="option" data-handle="${escapeAttr(p.handle)}" aria-selected="${isCurrentSelection ? 'true' : 'false'}" ${isSelected ? 'aria-disabled="true" disabled' : ''}>${productThumbnail(p)}<span class="wfcalc2__suggestion-copy"><strong>${escapeHtml(displayTitle(p))}</strong>${p.sku ? `<br><em>${escapeHtml(baseSku(p.sku))}</em>` : ''}${selectedState ? `<span class="wfcalc2__suggestion-state">${escapeHtml(selectedState)}</span>` : ''}</span></button>`;
      }).join('');
      box.querySelectorAll('[data-handle]').forEach(btn => {
        btn.addEventListener('keydown', event => handleSuggestionKeydown(event, box));
        btn.addEventListener('click', async () => {
        if(btn.getAttribute('aria-busy') === 'true') return;
        const selected = products.find(p => p.handle === btn.dataset.handle) || matches.find(p => p.handle === btn.dataset.handle);
        const selectionToken = (row.selectionToken || 0) + 1;
        row.selectionToken = selectionToken;
        const existingAssignment = selectedProductAssignment(selected?.handle, row.id);
        if(existingAssignment){
          setRowProductValidation(row, wfT("Already selected as Flavour {0}.", [existingAssignment.index + 1]));
          return;
        }
        // Keep the option focusable while loading so failed requests are easy to retry.
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('aria-busy', 'true');
        const hydrated = await hydrateProduct(selected);
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('aria-busy');
        if(row.selectionToken !== selectionToken || !state.rows.includes(row) || box.dataset.open === 'false') return;
        if(!hydrated){
          setRowProductValidation(row, wfT("Could not load this flavour’s prices and sizes. Select it again to retry."));
          return;
        }
        const assignmentAfterHydration = selectedProductAssignment(hydrated?.handle, row.id);
        if(assignmentAfterHydration){
          setRowProductValidation(row, wfT("Already selected as Flavour {0}.", [assignmentAfterHydration.index + 1]));
          return;
        }
        row.product = hydrated;
        row.densityOverride = null;
        row.productValidationMessage = '';
        row.purchaseVariantId = '';
        row.purchasePlanKey = '';
        row.purchaseSelectionTouched = false;
        const continueWithKeyboard = document.activeElement === btn && btn.matches(':focus-visible');
        renderRows(); formulaChanged();
        if(continueWithKeyboard) root.querySelector(`[data-row-id="${row.id}"] [data-usage]`)?.focus({ preventScroll:true });
        });
      });
    }
    box.hidden = false;
    syncSearchOpenState();
    positionSuggestions(box);
    box.closest('.wfcalc2__search-wrap')?.querySelector('[data-search]')?.setAttribute('aria-expanded', 'true');
  }

  function suggestionOptions(box){
    return [...(box?.querySelectorAll('[role="option"]:not([disabled])') || [])];
  }

  function handleSuggestionKeydown(event, box){
    const options = suggestionOptions(box);
    const currentIndex = options.indexOf(event.currentTarget);
    if(event.key === 'Escape'){
      event.preventDefault();
      const search = box.closest('.wfcalc2__search-wrap')?.querySelector('[data-search]');
      if(search) search.dataset.suppressSuggestions = 'true';
      closeSuggestions(box);
      search?.focus();
      window.setTimeout(() => { if(search) delete search.dataset.suppressSuggestions; }, 0);
      return;
    }
    let nextIndex = null;
    if(event.key === 'ArrowDown') nextIndex = currentIndex >= options.length - 1 ? 0 : currentIndex + 1;
    if(event.key === 'ArrowUp') nextIndex = currentIndex <= 0 ? options.length - 1 : currentIndex - 1;
    if(event.key === 'Home') nextIndex = 0;
    if(event.key === 'End') nextIndex = options.length - 1;
    if(nextIndex === null || !options.length) return;
    event.preventDefault();
    options[nextIndex]?.focus();
  }

  function setRowProductValidation(row, message){
    if(!row) return;
    row.productValidationMessage = message || '';
    const errorEl = rowsEl.querySelector(`[data-row-id="${row.id}"] [data-row-product-error]`);
    if(errorEl){
      errorEl.hidden = !row.productValidationMessage;
      errorEl.textContent = row.productValidationMessage;
    }
  }

  async function predictiveSearch(query){
    try{
      const code = String(query).trim().match(/^(SC|NC|RC)[\s\u2010-\u2015-]*(\d{3})(?:[\s\u2010-\u2015-]*(01|16|32|1G|5G|55|TT))?$/i);
      const remoteQuery = code ? [code[1], code[2], code[3]].filter(Boolean).join('-').toUpperCase() : query;
      const url = `${getShopifyRoot()}search/suggest.json?q=${encodeURIComponent(remoteQuery)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last`;
      const res = await fetch(url, { credentials:'same-origin' });
      if(!res.ok) return null;
      const json = await res.json();
      const items = json?.resources?.results?.products;
      if(!Array.isArray(items)) return null;
      return items.map(p => normalizeProduct({
        title: p.title,
        handle: p.handle,
        image: p.featured_image || p.image || '',
        // Shopify's SKU search can return an empty variants array. Retain the
        // exact query it matched without inventing prices, sizes or SKU data.
        matchedSkuQuery: code ? remoteQuery.replace(/-/g, '').toLowerCase() : '',
        variants: []
      })).filter(Boolean);
    }catch(e){ return null; }
  }

  async function hydrateProduct(product){
    product = normalizeProduct(product);
    if(!product) return null;
    if(product.variants?.length) return product;
    try{
      const res = await fetch(`${getShopifyRoot()}products/${encodeURIComponent(product.handle)}.js`, { credentials:'same-origin' });
      if(!res.ok) return null;
      const p = await res.json();
      if(!p.variants?.length) return null;
      return normalizeProduct({
        title: p.title,
        handle: p.handle,
        sku: p.variants?.[0]?.sku || '',
        image: product.image || p.featured_image || p.images?.[0] || '',
        sgRaw: product.sgRaw || parseSgText(p.description),
        densityRaw: product.densityRaw,
        variants: (p.variants || []).map(v => ({ id:String(v.id), title:v.title, sku:v.sku, priceCents:Number(v.price || 0), available:v.available }))
      });
    }catch(e){ return null; }
  }

  function calculate(){
    const basis = measurementBasis(currentBatchUnit());
    const batchBase = Math.min(MAX_BATCH_LITRES, measurementToBase(Math.max(0, currentBatchSize()), currentBatchUnit()));
    const basisPending = state.confirmedBasis !== basis;
    if(basisPending) state.confirmedBasis = null;
    syncMeasurementControls(basis, basisPending);
    const totalUsage = totalUsagePercent();
    const totalUsageOverMaximum = totalUsage > 100;
    const invalidNumber = !Number.isFinite(parseDecimal(batchSizeEl?.value)) || state.rows.some(row => row.usageRejected);
    const usageInvalid = totalUsageOverMaximum || invalidNumber;
    const duplicates = duplicateProductHandles();
    const densityMissing = basis === 'weight' && state.rows.some(row => Number(row.usage) > 0 && !flavourDensity(row).value);
    const purchasingBlocked = basisPending || usageInvalid || duplicates.size > 0 || densityMissing;
    const purchaseBlockReason = basisPending ? wfT("Confirm the usage rates by {0} to continue.", [basis])
      : invalidNumber ? wfT("Enter a valid number using a decimal comma or dot.")
      : usageInvalid ? wfT("Combined flavour usage must be 100% or less.")
      : duplicates.size ? wfT("Each flavour product can be selected only once. Remove the duplicate to see pricing and order sizes.")
      : densityMissing ? wfT("Enter a density for each flavour to estimate purchasing volume and cost.") : '';
    syncProductValidationMessages(duplicates);
    if(totalUsageEl) totalUsageEl.textContent = wfT("{0} by {1}", [formatPercent(totalUsage), basis]);
    const details = state.rows.map(row => {
      const p = row.product;
      const v = p?.variants?.[0] || null;
      const density = flavourDensity(row);
      const amounts = flavourAmounts(batchBase, basis, Number(row.usage || 0), density.value);
      const { neededMl, neededKg } = amounts;
      const optionSet = purchasingBlocked || neededMl === null
        ? { options:[], manualOptions:[], generatedVariants:[], recommendedPlan:null }
        : getPurchaseOptions(row, neededMl, policy);
      const options = optionSet.options || [];
      const recommendedPlan = optionSet.recommendedPlan || chooseRecommendedOption(options, policy);
      let plan = row.purchaseSelectionTouched ? optionSet.manualOptions?.find(option =>
        row.purchasePlanKey ? option.planKey === row.purchasePlanKey : option.variantId === String(row.purchaseVariantId || '')
      ) || null : recommendedPlan;
      if(!plan && recommendedPlan){
        plan = recommendedPlan;
        row.purchaseVariantId = '';
        row.purchasePlanKey = '';
        row.purchaseSelectionTouched = false;
      }
      return { row, p, v, density, sg:density.value, neededMl, neededKg, options,
        manualOptions:optionSet.manualOptions || [], generatedVariants:optionSet.generatedVariants || [],
        recommendedPlan:recommendedPlan || EMPTY_PURCHASE_PLAN,
        plan:plan || EMPTY_PURCHASE_PLAN, usedCost:0 };
    });
    details.forEach(detail => {
      const requiredEl = rowsEl.querySelector(`[data-row-id="${detail.row.id}"] [data-row-required]`);
      if(!requiredEl) return;
      requiredEl.hidden = batchBase <= 0 || usageInvalid || basisPending;
      requiredEl.textContent = requiredEl.hidden ? '' : formatRequiredAmount(detail);
    });
    updateUsageNote(totalUsage, details.length > 0, totalUsageOverMaximum);
    let totalPurchaseCost = 0, totalUsedCost = 0;
    details.forEach(d => {
      d.usedCost = d.plan.totalMl && d.neededMl !== null ? d.neededMl * (d.plan.totalPrice / d.plan.totalMl) : 0;
      totalPurchaseCost += d.plan.totalPrice || 0;
      totalUsedCost += d.usedCost || 0;
    });
    const packageInfo = finishedPackageCalculation(batchBase, basis);
    const completePricing = !purchasingBlocked && details.length > 0 && details.every(d => d.p && d.plan.items.length);
    if(costVolumeLabelEl) costVolumeLabelEl.textContent = wfT("Per {0} of mixture", [wfT(mixturePriceUnit())]);
    if(costPerVolumeEl) costPerVolumeEl.textContent = completePricing ? fmtUnitCost(mixtureUnitCost(totalUsedCost, batchBase)) : '—';
    if(detailsCostUsedEl) detailsCostUsedEl.textContent = completePricing ? fmtMoney(totalUsedCost) : '—';
    updateSimpleAnswer(details, batchBase, packageInfo, totalUsedCost, totalPurchaseCost, totalUsage, usageInvalid, purchaseBlockReason, basisPending);
    if(purchasingBlocked) renderBlockedPurchaseState(details, purchaseBlockReason);
    else renderPurchaseCheck(details);
    updateFormulaExport(details, batchBase, packageInfo, totalUsedCost, totalPurchaseCost, totalUsage, purchasingBlocked);
    syncMobileAction();
    if(calculationDetailsEl){
      calculationDetailsEl.hidden = !details.some(d => d.p);
      if(calculationDetailsEl.hidden) calculationDetailsEl.open = false;
    }
    if(weightRowsEl){
      const weightedDetails = !basisPending && !usageInvalid ? details.filter(d => d.p && d.density.value && Number.isFinite(d.neededKg)) : [];
      weightRowsEl.innerHTML = weightedDetails.map(d => `<div class="wfcalc2__weight-row"><span>${escapeHtml(displayTitle(d.p))}</span><strong>${escapeHtml(formatWeight(d.neededKg))} · ${escapeHtml(d.density.note)}</strong></div>`).join('');
      weightRowsEl.hidden = weightedDetails.length === 0;
      if(weightHeadingEl) weightHeadingEl.hidden = weightedDetails.length === 0;
    }
    updateTestBatchButtonLabel();
  }

  function updateSimpleAnswer(details, batchBase, packageInfo, usedCost, purchaseCost, totalUsage, usageInvalid, purchaseBlockReason, basisPending){
    const purchasingBlocked = Boolean(purchaseBlockReason);
    const basis = measurementBasis(currentBatchUnit());
    const hasCompleteProductSelection = details.length > 0 && details.every(d => d.p);
    const hasCompletePricing = hasCompleteProductSelection && details.every(d => d.v && d.plan?.items?.length);
    const priced = purchasingBlocked || !hasCompletePricing ? [] : details;
    const totalNeededMl = details.reduce((sum,d) => sum + Number(d.neededMl || 0), 0);
    const totalNeededKg = details.reduce((sum,d) => sum + Number(d.neededKg || 0), 0);
    const mainNeed = basis === 'weight' ? formatWeight(totalNeededKg) : formatVolumeForBatchUnit(totalNeededMl);
    const hasAmount = !usageInvalid && !basisPending && batchBase > 0 && totalUsage > 0;
    const volumeEstimate = basis === 'weight' && details.every(d => d.neededMl !== null)
      ? ` · Approx. ${formatComputedVolume(totalNeededMl)}` : '';
    if(needLabelEl) needLabelEl.textContent = wfT("You need");
    if(needMainEl) needMainEl.textContent = basisPending ? wfT("Confirm usage") : usageInvalid ? wfT("Check usage") : hasAmount ? mainNeed : wfT("Enter values");
    if(needCaptionEl) needCaptionEl.textContent = basisPending ? wfT("Usage rates are now by {0}", [basis]) : usageInvalid ? purchaseBlockReason : hasAmount ? wfT("flavour required") : wfT("Batch size and usage");
    if(needSubEl) needSubEl.textContent = hasAmount ? wfT("{0} by {1} of {2}{3}", [formatPercent(totalUsage), basis, formatBatchInputLabel(batchBase), volumeEstimate]) : '';
    if(resultCurrencyEl) resultCurrencyEl.hidden = priced.length === 0;
    if(pricingPromptEl){
      pricingPromptEl.hidden = priced.length > 0 || usageInvalid;
      pricingPromptEl.textContent = purchaseBlockReason || productSelectionPrompt(details) || wfT("Pricing and order sizes are unavailable for this quantity.");
    }
    if(packageSettingsEl) packageSettingsEl.hidden = priced.length === 0;
    if(quickMetricsEl) quickMetricsEl.hidden = priced.length === 0;
    if(orderSummaryEl) orderSummaryEl.hidden = priced.length === 0;
    if(mobileSummaryEl) mobileSummaryEl.dataset.ready = priced.length ? 'true' : 'false';
    const remainingMl = priced.reduce((sum,d) => sum + Math.max(0, Number(d.plan.leftoverMl || 0)), 0);
    if(packageCostLabelEl) packageCostLabelEl.textContent = wfT("Flavour cost per {0}", [packageInfo.label]);
    const packageCost = packageInfo.count > 0 ? usedCost / packageInfo.count : null;
    if(summaryPackageCostEl) summaryPackageCostEl.textContent = priced.length && packageCost !== null ? fmtUnitCost(packageCost) : '—';
    if(summaryCostUsedEl) summaryCostUsedEl.textContent = priced.length ? fmtMoney(usedCost) : '—';
    if(orderTotalEl) orderTotalEl.textContent = priced.length ? fmtMoney(purchaseCost) : '—';
    if(summarySpareEl) summarySpareEl.textContent = priced.length ? formatComputedVolume(remainingMl) : '—';
    if(orderExclusionsEl) orderExclusionsEl.hidden = priced.length === 0;
    if(mobileNeedEl) mobileNeedEl.textContent = basisPending ? wfT("Confirm usage") : usageInvalid ? wfT("Check usage") : hasAmount ? mainNeed : wfT("Enter batch and usage");
    if(mobilePackageLabelEl) mobilePackageLabelEl.textContent = wfT("Order subtotal");
    if(mobilePackageCostEl) mobilePackageCostEl.textContent = priced.length ? fmtMoney(purchaseCost) : wfT("Select flavour");
    queueMobileSummaryReserve();
  }

  function productSelectionPrompt(details, short){
    const missingProductCount = details.filter(detail => !detail.p).length;
    if(!missingProductCount) return '';
    if(short) return details.length > 1 ? wfT("Select all products") : wfT("Select product");
    if(details.length === 1) return wfT("Select a product to see pricing and order sizes.");
    if(missingProductCount === details.length) return wfT("Select a product for every flavour to see pricing and order sizes.");
    return wfT("Select products for the remaining flavours to see pricing and order sizes.");
  }

  function renderBlockedPurchaseState(details, reason){
    if(purchaseEl) purchaseEl.hidden = true;
    purchaseListEl.innerHTML = '';
    if(orderTotalEl) orderTotalEl.textContent = '—';
    if(addAllBtn){
      const hasSelectedFlavour = details.some(detail => detail.p && detail.v);
      addAllBtn.hidden = !hasSelectedFlavour;
      addAllBtn.disabled = true;
      addAllBtn.dataset.items = '[]';
      addAllBtn.dataset.defaultText = wfT("Add to cart");
      if(addAllBtnText) addAllBtnText.textContent = wfT("Add to cart");
    }
    if(volumeContactEl) volumeContactEl.hidden = true;
    queueMobileSummaryReserve();
  }

  function renderPurchaseCheck(details){
    const hasCompleteProductSelection = details.length > 0 && details.every(detail => detail.p);
    const selectionPrompt = productSelectionPrompt(details);
    const usable = details.filter(d => d.p && d.options?.length);
    if(!hasCompleteProductSelection || usable.length !== details.length){
      if(purchaseEl) purchaseEl.hidden = true;
      purchaseListEl.innerHTML = '';
      if(addAllBtn){
        addAllBtn.hidden = true;
        addAllBtn.dataset.items = '[]';
      }
      if(volumeContactEl) volumeContactEl.hidden = true;
      if(orderTotalEl) orderTotalEl.textContent = hasCompleteProductSelection
        ? wfT("Size unavailable")
        : wfT("Select a flavour for pricing.");
      queueMobileSummaryReserve();
      return;
    }

    if(purchaseEl) purchaseEl.hidden = false;
    if(purchaseHeadingEl) purchaseHeadingEl.textContent = wfT("What to order");
    const isSingleFlavour = usable.length === 1;
    const allItems = [];
    const orderRows = usable.map(d => {
      const selectedPlan = d.plan;
      const selectedPlanDisplay = purchasePlanPresentation(selectedPlan);
      const recommendation = d.recommendedPlan?.items?.length
        ? d.recommendedPlan
        : chooseRecommendedOption(d.options, policy);
      const upsell = isSingleFlavour
        ? findQualifiedUpsell(d.generatedVariants, d.manualOptions, recommendation)
        : null;
      if(selectedPlan.items?.length){
        allItems.push(...selectedPlan.items.map(i => ({
          id:String(i.id),
          quantity:Math.max(1, Math.floor(Number(i.quantity || 1)))
        })));
      }

      const leftover = formatComputedVolume(selectedPlan.leftoverMl);
      const selectedIsRecommendation = samePurchasePlan(selectedPlan, recommendation);
      let alternativeMarkup = '';

      if(upsell && selectedIsRecommendation){
        const upsellDisplay = purchasePlanPresentation(upsell);
        const recommendationDisplay = purchasePlanPresentation(recommendation);
        const savingPercent = Math.round(((recommendation.costPerLitre - upsell.costPerLitre) / recommendation.costPerLitre) * 100);
        const additionalSpend = Math.max(0, upsellDisplay.totalPrice - recommendationDisplay.totalPrice);
        const unitLabel = computedPriceUnitLabel() === 'L' ? 'litre' : 'US gallon';
        alternativeMarkup = `<div class="wfcalc2__single-alternative">
          <span>${escapeHtml(upsellDisplay.label)} costs ${fmtMoney(additionalSpend)} more and saves ${formatNumber(savingPercent, 0)}% per ${escapeHtml(unitLabel)}.</span>
          <button
            type="button"
            class="button-secondary wfcalc2__secondary-btn"
            data-wf-switch-option
            data-row-id="${escapeAttr(d.row.id)}"
            data-variant-id="${escapeAttr(upsell.variantId)}"
            data-plan-key="${escapeAttr(upsell.planKey)}"
            data-use-recommendation="false"
          >${wfH("Use this size")}</button>
        </div>`;
      }
      const productUrl = `${getShopifyRoot()}products/${encodeURIComponent(String(d.p.handle || ''))}`;
      const sizeOptionsMarkup = (d.manualOptions || []).map(option => {
        const isSelected = samePurchasePlan(selectedPlan, option);
        const optionDisplay = purchasePlanPresentation(option);
        const cheaperPlanCopy = option.isCheaperAlternative
          ? wfH('Saves {0} · {1} {2} instead of {3}', [fmtMoney(option.savingsVsRecommendation), option.count, option.count === 1 ? 'container' : 'containers', option.recommendationContainerCount])
          : wfH('{0} spare', [formatComputedVolume(option.leftoverMl)]);
        return `<button
          type="button"
          class="button-unstyled wfcalc2__size-option"
          data-wf-size-option
          data-row-id="${escapeAttr(d.row.id)}"
          data-variant-id="${escapeAttr(option.variantId)}"
          data-plan-key="${escapeAttr(option.planKey)}"
          aria-pressed="${isSelected ? 'true' : 'false'}"
        >
          <span><strong>${escapeHtml(optionDisplay.label)}</strong></span>
          <span><strong>${fmtMoney(optionDisplay.totalPrice)} total</strong><small>${cheaperPlanCopy}</small></span>
          <span><strong>${formatComputedUnitPrice(option.costPerLitre)}</strong></span>
        </button>`;
      }).join('');
      const recommendationReturn = !selectedIsRecommendation
        ? `<button type="button" class="button-unstyled wfcalc2__recommendation-return" data-wf-use-recommendation data-row-id="${escapeAttr(d.row.id)}">${wfH('Use the recommended order')}</button>`
        : '';
      const identityMarkup = `<span class="wfcalc2__order-identity">${productThumbnail(d.p)}<strong title="${escapeAttr(displayTitle(d.p))}">${escapeHtml(displayTitle(d.p))}</strong></span>`;
      const requiredMarkup = `<span class="wfcalc2__order-required">${wfH('{0} required', [formatRequiredAmount(d)])}</span>`;

      return `<details class="wfcalc2__order-row" name="${escapeAttr(`${root.id}-order`)}">
        <summary aria-expanded="false">
          ${identityMarkup}
          ${requiredMarkup}
          <span class="wfcalc2__order-plan"><span class="wfcalc2__plan-badge">${selectedIsRecommendation ? wfT("Recommended") : wfT("Selected")}</span><strong>${escapeHtml(selectedPlanDisplay.label)}</strong></span>
          <strong class="wfcalc2__order-total">${fmtMoney(selectedPlanDisplay.totalPrice)}</strong>
          <span class="wfcalc2__order-chevron" aria-hidden="true"></span>
        </summary>
        <div class="wfcalc2__order-row-details">
          <dl class="wfcalc2__order-meta">
            <div><dt>${wfH('Price per {0}', [computedPriceUnitLabel()])}</dt><dd>${fmtUnitCost(costPerComputedVolume(selectedPlan.costPerLitre))}</dd></div>
            <div><dt>${wfH('Spare after formula')}</dt><dd>${escapeHtml(leftover)}</dd></div>
          </dl>
          ${alternativeMarkup}
          ${sizeOptionsMarkup ? `<div class="wfcalc2__size-options" aria-label="${wfH("Other practical order sizes for {0}", [displayTitle(d.p)])}">${sizeOptionsMarkup}</div>` : ''}
          ${recommendationReturn}
          <a class="wfcalc2__product-link" href="${escapeAttr(productUrl)}">${wfH("Open the {0} product page", [displayTitle(d.p)])}</a>
        </div>
      </details>`;
    }).join('');

    const tableHead = `<div class="wfcalc2__order-table-head" aria-hidden="true"><span>${wfH("Flavour")}</span><span>${wfH("Required")}</span><span>${wfH("What to order")}</span><span>${wfH("Total")}</span><span></span></div>`;
    const hasFreight = usable.some(detail => detail.plan.items?.some(item => Number(item.ml || 0) >= policy.toteUnlockGallons * ML_PER_US_GALLON));
    const showVolumeContact = usable.some(detail =>
      [...(detail.plan.items || []), ...(detail.recommendedPlan.items || [])]
        .some(item => Number(item.ml || 0) >= policy.toteUnlockGallons * ML_PER_US_GALLON)
    );
    const totalSpareMl = usable.reduce((sum, detail) => sum + Math.max(0, Number(detail.plan.leftoverMl || 0)), 0);
    const allRecommendations = usable.every(detail => samePurchasePlan(detail.plan, detail.recommendedPlan));
    const spareNote = spareVolumeCopy(totalSpareMl, allRecommendations);
    purchaseListEl.innerHTML = `
      <div class="wfcalc2__order-table">
        ${tableHead}
        ${orderRows}
      </div>
      <p class="wfcalc2__purchase-note">${escapeHtml(spareNote)}</p>
      ${hasFreight ? `<p class="wfcalc2__purchase-note">${escapeHtml(FREIGHT_NOTE_TEXT)}</p>` : ''}`;

    const orderDisclosureRows = [...purchaseListEl.querySelectorAll('.wfcalc2__order-row')];
    orderDisclosureRows.forEach(orderRow => {
      const summary = orderRow.querySelector(':scope > summary');
      const syncExpandedState = () => summary?.setAttribute('aria-expanded', orderRow.open ? 'true' : 'false');
      syncExpandedState();
      orderRow.addEventListener('toggle', () => {
        if(orderRow.open){
          orderDisclosureRows.forEach(otherRow => {
            if(otherRow !== orderRow && otherRow.open) otherRow.open = false;
          });
        }
        syncExpandedState();
      });
    });

    purchaseListEl.querySelectorAll('[data-wf-switch-option]').forEach(button => {
      button.addEventListener('click', () => {
        const row = state.rows.find(item => item.id === button.dataset.rowId);
        if(!row) return;
        const useRecommendation = button.dataset.useRecommendation === 'true';
        row.purchaseVariantId = useRecommendation ? '' : button.dataset.variantId;
        row.purchasePlanKey = useRecommendation ? '' : button.dataset.planKey;
        row.purchaseSelectionTouched = !useRecommendation;
        formulaChanged();
      });
    });

    purchaseListEl.querySelectorAll('[data-wf-size-option]').forEach(button => {
      button.addEventListener('click', () => {
        const row = state.rows.find(item => item.id === button.dataset.rowId);
        if(!row) return;
        row.purchaseVariantId = button.dataset.variantId;
        row.purchasePlanKey = button.dataset.planKey;
        row.purchaseSelectionTouched = true;
        formulaChanged();
      });
    });

    purchaseListEl.querySelectorAll('[data-wf-use-recommendation]').forEach(button => {
      button.addEventListener('click', () => {
        const row = state.rows.find(item => item.id === button.dataset.rowId);
        if(!row) return;
        row.purchaseVariantId = '';
        row.purchasePlanKey = '';
        row.purchaseSelectionTouched = false;
        formulaChanged();
      });
    });

    const purchaseTotal = usable.reduce((sum, detail) => sum + purchasePlanPresentation(detail.plan).totalPrice, 0);
    if(orderTotalEl) orderTotalEl.textContent = fmtMoney(purchaseTotal);
    if(addAllBtn){
      addAllBtn.hidden = !allItems.length;
      addAllBtn.disabled = false;
      addAllBtn.dataset.items = JSON.stringify(mergeCartItems(allItems));
      const buttonLabel = wfT("Add to cart");
      addAllBtn.dataset.defaultText = buttonLabel;
      if(addAllBtnText) addAllBtnText.textContent = buttonLabel;
    }
    if(volumeContactEl) volumeContactEl.hidden = !showVolumeContact;
    queueMobileSummaryReserve();
  }

  function updateUsageNote(totalUsage, hasPricing, totalUsageInvalid){
    if(!totalUsageNoteEl) return;
    if(totalUsageInvalid){
      totalUsageNoteEl.hidden = false;
      totalUsageNoteEl.textContent = wfT("Total usage is {0}. Combined flavour usage cannot exceed 100%.", [formatPercent(totalUsage)]);
      return;
    }
    const showNote = Boolean(hasPricing) && totalUsage > implausibleUsageThreshold;
    totalUsageNoteEl.hidden = !showNote;
    totalUsageNoteEl.textContent = showNote
      ? wfT("Total flavour usage is {0}. Confirm this dosage in a small test batch before production.", [formatPercent(totalUsage)])
      : '';
  }

  function applyTargetPackages(){
    const { valid, count, yieldPercent, batchBase, targetUnit } = targetBatchCalculation();
    if(!valid) return;
    batchSizeEl.value = numForBatchInput(isWeightUnit(targetUnit) ? weightFromKg(batchBase, targetUnit) : volumeFromLitres(batchBase, targetUnit));
    batchUnitEl.value = targetUnit;
    packageEl.value = 'count';
    state.packageTouched = true;
    finishedCountEl.value = String(count);
    customPackageWrap.hidden = true;
    enforceBatchSizeLimit();
    formulaChanged();
    if(targetResultEl) targetResultEl.textContent = wfT("Batch size set to {0} for {1} finished units at {2} yield.", [formatBatchInputLabel(batchBase), formatNumber(count,0), formatPercent(yieldPercent)]);
  }

  function updateFormulaExport(details, batchBase, packageInfo, usedCost, purchaseTotal, totalUsage, purchasingBlocked){
    const basis = measurementBasis(currentBatchUnit());
    const lines = [wfT("Wonder Flavours Formula Summary"), '', wfT("Batch size: {0}", [formatBatchInputLabel(batchBase)]), wfT("Total flavour usage: {0} by {1}", [formatPercent(totalUsage), basis])];
    if(packageInfo.count > 0) lines.push(wfT("Finished units: {0} ({1})", [formatNumber(packageInfo.count,3), packageInfo.label]));
    else lines.push(`Package calculation: ${packageInfo.error}`);
    const completePricing = !purchasingBlocked && details.length > 0 && details.every(d => d.p && d.plan.items.length);
    if(completePricing){
      lines.push(wfT("Flavour cost used in batch: {0}", [fmtMoney(usedCost)]));
      lines.push(wfT("Flavour cost per {0} of mixture: {1}", [mixturePriceUnit(), fmtUnitCost(mixtureUnitCost(usedCost, batchBase))]));
      if(packageInfo.count > 0) lines.push(wfT("Flavour cost per {0}: {1}", [packageInfo.label, fmtUnitCost(usedCost / packageInfo.count)]));
      lines.push(wfT("Product subtotal: {0}", [fmtMoney(purchaseTotal)]));
    }
    if(state.confirmedBasis !== basis) lines.push(wfT("Usage rates need confirmation for this measurement basis."));
    lines.push('', 'Flavours:');
    details.forEach((d, i) => {
      lines.push(`- ${displayTitle(d.p) || wfT("Flavour {0}", [i + 1])}${d.p && baseSku(d.v?.sku || d.p.sku || '') ? ` (${baseSku(d.v?.sku || d.p.sku || '')})` : ''}`);
      lines.push(wfT("  Usage: {0} by {1}", [formatPercent(d.row.usage), basis]));
      if(state.confirmedBasis === basis) lines.push(wfT("  Amount needed: {0}", [formatRequiredAmount(d)]));
      if(d.density.value) lines.push(wfT("  Density: {0} g/mL. {1}", [d.density.value, d.density.note]));
      if(completePricing){
        const plan = purchasePlanPresentation(d.plan);
        lines.push(wfT("  Selected purchase: {0} ({1})", [plan.label, fmtMoney(plan.totalPrice)]), wfT("  Flavour cost used: {0}", [fmtMoney(d.usedCost)]));
      }
    });
    lines.push('', packageInfo.assumption || '', 'Calculations are estimates. Start with small test batches and adjust to taste.');
    formulaSummaryText = lines.filter(line => line !== undefined).join('\n');
  }

  async function copyFormulaSummary(){
    const text = formulaSummaryText;
    if(!text){ if(copyStatusEl) copyStatusEl.textContent = wfT("Nothing to copy yet."); return; }
    try{
      await navigator.clipboard.writeText(text);
      if(copyStatusEl) copyStatusEl.textContent = wfT("Formula summary copied.");
    }catch(e){
      const temporary = document.createElement('textarea');
      temporary.value = text;
      temporary.setAttribute('readonly', '');
      temporary.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0;';
      document.body.appendChild(temporary);
      temporary.select();
      const copied = document.execCommand('copy');
      temporary.remove();
      if(copyStatusEl) copyStatusEl.textContent = copied ? wfT("Formula summary copied.") : wfT("Copy failed. Check browser clipboard permissions.");
    }
    window.setTimeout(() => { if(copyStatusEl) copyStatusEl.textContent = ''; }, 2200);
  }

  async function addItemsToCart(items){
    if(addAllBtn?.dataset.loading === 'true') return;
    const merged = mergeCartItems(items)
      .map(i => ({ id: String(i.id || '').replace(/[^0-9]/g,''), quantity: Math.max(1, Math.floor(Number(i.quantity || 1))) }))
      .filter(i => i.id && i.quantity > 0);

    if(!merged.length){
      setCartStatus(wfT("Nothing was added. Please choose a flavour size first."));
      return;
    }

    setCartStatus(wfT("Adding to cart…"));
    setCartLoading(true);

    try{
      const cart = await import(root.dataset.cartModule);
      const result = await cart.addItemsToCart(merged, root, 'wf-calculator');
      if(result.cartRefreshFailed){
        window.location.href = `${getShopifyRoot()}cart`;
        return;
      }

      setCartStatus(wfT("Added to cart."));
      if(addAllBtn){
        addAllBtn.dataset.added = 'true';
        window.setTimeout(() => { delete addAllBtn.dataset.added; }, 1600);
      }
    }catch(e){
      console.error('[WF Calculator] Cart add failed:', e, items);
      setCartStatus(e?.cartRejected
        ? wfT("{0} Your selection is still here. Review your cart before trying again.", [e.message])
        : wfT("We could not confirm the cart update. Your selection is still here. Review your cart before trying again."));
    }finally{
      setCartLoading(false);
    }
  }

  function getShopifyRoot(){
    let rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    if(!rootPath.endsWith('/')) rootPath += '/';
    return rootPath;
  }

  function setCartStatus(msg){ if(cartStatusEl) cartStatusEl.textContent = msg || ''; }

  function setCartLoading(loading){
    if(!addAllBtn) return;
    addAllBtn.dataset.loading = loading ? 'true' : 'false';
    addAllBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
    if(addAllBtnText) addAllBtnText.textContent = loading ? wfT("Adding…") : (addAllBtn.dataset.defaultText || wfT("Add selected size"));
    const hasItems = safeJson(addAllBtn.dataset.items || '[]', []).length > 0;
    addAllBtn.disabled = loading;
    addAllBtn.hidden = !hasItems;
  }

  function mergeCartItems(items){
    const map = new Map();
    (items || []).forEach(i => {
      const id = String(i.id || '');
      const qty = Number(i.quantity || 0);
      if(!id || qty <= 0) return;
      map.set(id, (map.get(id) || 0) + qty);
    });
    return [...map.entries()].map(([id, quantity]) => ({ id:String(id), quantity }));
  }

  function getPurchaseOptions(row, neededMl, policy){
    // Keep only the latest result; prices, availability and policy are part of its identity.
    const key = JSON.stringify([row.product?.variants, neededMl, policy]);
    if(row.purchaseOptions?.key !== key){
      row.purchaseOptions = { key, value:buildVariantOptions(row.product, neededMl, policy) };
    }
    return row.purchaseOptions.value;
  }

  function buildVariantOptions(product, neededMl, policy){
    if(!product?.variants?.length || !neededMl){
      return { options:[], manualOptions:[], generatedVariants:[], recommendedPlan:null };
    }

    const allVariants = product.variants
      .map(v => ({
        ...v,
        id:String(v.id || ''),
        ml:parseBottleMl(v.title || ''),
        price:(Number(v.priceCents || 0))/100
      }))
      .filter(v => v.ml && v.id && v.price >= 0 && v.available !== false)
      .sort((a,b) => a.ml - b.ml || a.price - b.price);

    const toteUnlocked = neededMl > policy.toteUnlockGallons * ML_PER_US_GALLON;
    const generatedVariants = allVariants.filter(variant => {
      const ladderIndex = generatedLadderIndex(variant);
      if(ladderIndex < 0) return false;
      if(ladderIndex === 5 && !toteUnlocked) return false;
      return true;
    });
    const rawManualOptions = allVariants.map(variant => buildSingleSizePlan(variant, neededMl));
    if(!generatedVariants.length){
      return {
        options:[],
        manualOptions:buildDisplaySizeOptions(rawManualOptions, null, allVariants, policy),
        generatedVariants:[],
        recommendedPlan:null
      };
    }

    // Apply the spare-volume minimum to each flavour's purchase, not its recipe usage.
    const coverageResult = findCheapestCoveragePlan(
      generatedVariants,
      neededMl * (1 + policy.headroomTarget),
      policy
    );
    let recommendedPlan = coverageResult.plan;
    if(recommendedPlan){
      recommendedPlan = {
        ...recommendedPlan,
        leftoverMl:Math.max(0, recommendedPlan.totalMl - neededMl),
        isRecommended:true
      };
    }

    const cheapestCoveringPlan = coverageResult.cheapestPlan
      ? {
        ...coverageResult.cheapestPlan,
        leftoverMl:Math.max(0, coverageResult.cheapestPlan.totalMl - neededMl)
      }
      : null;
    const cheaperPlanSavings = recommendedPlan && cheapestCoveringPlan
      ? recommendedPlan.totalPrice - cheapestCoveringPlan.totalPrice
      : 0;
    const cheaperPlanSavingsRate = recommendedPlan?.totalPrice
      ? cheaperPlanSavings / recommendedPlan.totalPrice
      : 0;
    const showCheaperCoveringPlan = Boolean(
      recommendedPlan &&
      cheapestCoveringPlan &&
      !samePurchasePlan(recommendedPlan, cheapestCoveringPlan) &&
      cheaperPlanSavings > 0.005 &&
      cheaperPlanSavingsRate > policy.cheaperPlanSavingsTolerance
    );
    const cheaperSelectablePlan = showCheaperCoveringPlan
      ? {
        ...cheapestCoveringPlan,
        isCheaperAlternative:true,
        savingsVsRecommendation:cheaperPlanSavings,
        recommendationContainerCount:recommendedPlan.count
      }
      : null;
    const manualOptions = buildDisplaySizeOptions(
      rawManualOptions,
      recommendedPlan,
      allVariants,
      policy,
      [cheaperSelectablePlan]
    );

    return {
      options:recommendedPlan ? [recommendedPlan] : [],
      manualOptions,
      generatedVariants,
      recommendedPlan
    };
  }

  function generatedLadderIndex(variant){
    const ounces = Number(variant?.ml || 0) / ML_PER_US_OZ;
    const ladderOunces = [16, 32, 128, 640, 7040, 35200];
    return ladderOunces.findIndex(value => Math.abs(ounces - value) <= Math.max(0.25, value * 0.002));
  }

  function buildSingleSizePlan(variant, neededMl){
    const quantity = Math.max(1, Math.ceil((neededMl - 0.0001) / variant.ml));
    return makePurchasePlan([quantity], [variant], neededMl);
  }

  function buildDisplaySizeOptions(rawManualOptions, recommendation, availableVariants, policy, extraCandidates = []){
    const uniqueCandidates = [];
    const seenPlanKeys = new Set();
    [recommendation, ...(extraCandidates || []), ...(rawManualOptions || [])].filter(Boolean).forEach(option => {
      if(!option.planKey || seenPlanKeys.has(option.planKey)) return;
      seenPlanKeys.add(option.planKey);
      uniqueCandidates.push(option);
    });

    const referenceOption = recommendation || extraCandidates.find(Boolean) || rawManualOptions.find(Boolean);
    const requiredMl = referenceOption
      ? Math.max(0, Number(referenceOption.totalMl || 0) - Number(referenceOption.leftoverMl || 0))
      : 0;
    const practicalCoverageCeilingMl = requiredMl ? requiredMl * 2.25 : Number.POSITIVE_INFINITY;

    return filterDominatedOptions(uniqueCandidates)
      .filter(option => !samePurchasePlan(option, recommendation))
      .filter(option => !exceedsSmallFormatLimit(option.items?.map(item => item.quantity) || [], option.items || [], availableVariants, policy))
      .filter(option => option.isCheaperAlternative || option.totalMl <= practicalCoverageCeilingMl + 0.0001)
      .sort((a,b) =>
        Number(Boolean(b.isCheaperAlternative)) - Number(Boolean(a.isCheaperAlternative)) ||
        a.totalMl - b.totalMl ||
        a.totalPrice - b.totalPrice ||
        a.count - b.count
      )
      .slice(0, 2);
  }

  function isSmallFormatWithLargerAvailable(variant, availableVariants, policy){
    const volume = Number(variant?.ml || 0);
    if(!volume || volume > policy.smallFormatMaxMl + 0.0001) return false;
    return (availableVariants || []).some(other => Number(other?.ml || 0) > volume + 0.0001);
  }

  function exceedsSmallFormatLimit(counts, variants, availableVariants = variants, policy){
    return (counts || []).some((quantity, index) =>
      Number(quantity || 0) > policy.maxSmallFormatUnits &&
      isSmallFormatWithLargerAvailable(variants[index], availableVariants, policy)
    );
  }

  function makePurchasePlan(counts, variants, neededMl){
    const items = variants.map((variant, index) => ({
      id:variant.id,
      title:variant.title,
      quantity:Number(counts[index] || 0),
      ml:variant.ml,
      price:variant.price
    })).filter(item => item.quantity > 0).sort((a,b) => b.ml - a.ml || a.price - b.price);
    const totalMl = items.reduce((sum, item) => sum + item.quantity * item.ml, 0);
    const totalPrice = items.reduce((sum, item) => sum + item.quantity * item.price, 0);
    const count = items.reduce((sum, item) => sum + item.quantity, 0);
    const singleVariant = items.length === 1 ? items[0] : null;
    return {
      variantId:singleVariant?.id || '',
      id:singleVariant?.id || '',
      title:singleVariant?.title || '',
      quantity:singleVariant?.quantity || count,
      ml:Math.max(0, ...items.map(item => item.ml)),
      unitPrice:singleVariant?.price || 0,
      totalMl,
      totalPrice,
      leftoverMl:Math.max(0, totalMl - neededMl),
      costPerLitre:totalMl ? totalPrice / (totalMl / 1000) : 0,
      count,
      distinctSizeCount:items.length,
      label:items.map(item => `${item.quantity} × ${item.title}`).join(' + '),
      planKey:items.map(item => `${item.id}:${item.quantity}`).sort().join('|'),
      items
    };
  }

  function purchasePlanPresentation(plan){
    const items = Array.isArray(plan?.items)
      ? plan.items.filter(item => Number(item?.quantity || 0) > 0)
      : [];
    return {
      label:items.length
        ? items.map(item => `${Number(item.quantity)} × ${item.title}`).join(' + ')
        : String(plan?.label || ''),
      totalPrice:items.length
        ? items.reduce((sum, item) => sum + Number(item.quantity || 0) * Number(item.price || 0), 0)
        : Number(plan?.totalPrice || 0)
    };
  }

  function findCheapestCoveragePlan(variants, targetMl, policy){
    if(!variants?.length || !targetMl) return { plan:null };
    const baseMl = Math.min(...variants.map(variant => variant.ml));
    const variantUnits = variants.map(variant => Math.max(1, Math.round(variant.ml / baseMl)));
    const targetUnits = Math.max(1, Math.ceil((targetMl - 0.0001) / baseMl));
    const maxUnits = Math.max(...variantUnits);
    const maxDpUnits = 250000;
    const prefixCounts = variants.map(() => 0);
    let prefixUnits = 0;

    if(targetUnits > maxDpUnits){
      const bulkCandidates = variants.map((variant, index) => ({
        index,
        costPerUnit:variant.price / variantUnits[index]
      })).filter(candidate => !isSmallFormatWithLargerAvailable(variants[candidate.index], variants, policy));
      const bulkIndex = (bulkCandidates.length ? bulkCandidates : variants.map((variant, index) => ({
        index,
        costPerUnit:variant.price / variantUnits[index]
      }))).sort((a,b) => a.costPerUnit - b.costPerUnit || variantUnits[b.index] - variantUnits[a.index])[0].index;
      const prefixQuantity = Math.max(0, Math.floor((targetUnits - maxDpUnits) / variantUnits[bulkIndex]));
      prefixCounts[bulkIndex] = prefixQuantity;
      prefixUnits = prefixQuantity * variantUnits[bulkIndex];
    }

    const remainingTarget = targetUnits - prefixUnits;
    const limit = remainingTarget + maxUnits - 1;
    const maxSizeTypes = Math.min(variants.length, policy.maxRecommendationSizeTypes);
    const prefixSizeTypes = prefixCounts.filter(quantity => quantity > 0).length;
    const prefixPrice = prefixCounts.reduce((price, quantity, index) => price + quantity * variants[index].price, 0);
    const priceCeiling = Math.min(...variants.map((variant, index) => {
      const counts = prefixCounts.slice();
      counts[index] += Math.ceil(remainingTarget / variantUnits[index]);
      if(counts.filter(quantity => quantity > 0).length > maxSizeTypes ||
        exceedsSmallFormatLimit(counts, variants, variants, policy)) return Infinity;
      return counts.reduce((price, quantity, index) => price + quantity * variants[index].price, 0);
    })) * (1 + policy.simplicityBand) + 0.005;
    const dp = Array.from({ length:maxSizeTypes + 1 }, () => []);
    dp[prefixSizeTypes][0] = { price:0, count:0, counts:variants.map(() => 0) };
    const improves = (price, count, existing) => !existing || price < existing.price - 0.005 ||
      (Math.abs(price - existing.price) <= 0.005 && count < existing.count);

    variants.forEach((variant, variantIndex) => {
      const packUnits = variantUnits[variantIndex];
      const smallFormat = isSmallFormatWithLargerAvailable(variant, variants, policy);
      const maxQuantity = smallFormat ? policy.maxSmallFormatUnits - prefixCounts[variantIndex] : 1;
      const addedSizeType = prefixCounts[variantIndex] ? 0 : 1;
      for(let sizeTypes = maxSizeTypes; sizeTypes >= prefixSizeTypes + addedSizeType; sizeTypes--){
        const previous = dp[sizeTypes - addedSizeType];
        if(!previous.length) continue;
        const withVariant = [];
        const addPacks = (current, units, quantity) => {
          const nextUnits = units + packUnits * quantity;
          if(nextUnits > limit) return;
          const price = current.price + variant.price * quantity;
          if(prefixPrice + price > priceCeiling) return;
          const count = current.count + quantity;
          if(!improves(price, count, withVariant[nextUnits])) return;
          const counts = current.counts.slice();
          counts[variantIndex] += quantity;
          withVariant[nextUnits] = { price, count, counts };
        };
        const sourceLimit = smallFormat ? previous.length - 1 : limit;
        for(let units = 0; units <= sourceLimit; units++){
          const current = previous[units];
          if(current){
            const quantityLimit = Math.min(maxQuantity, Math.floor((limit - units) / packUnits));
            for(let quantity = 1; quantity <= quantityLimit; quantity++) addPacks(current, units, quantity);
          }
          if(!smallFormat && withVariant[units]) addPacks(withVariant[units], units, 1);
        }
        for(let units = 0; units < withVariant.length; units++){
          const result = withVariant[units];
          if(result && improves(result.price, result.count, dp[sizeTypes][units])) dp[sizeTypes][units] = result;
        }
      }
    });

    const candidates = [];
    for(const states of dp){
      for(let units = remainingTarget; units <= limit; units++){
        const result = states[units];
        if(!result) continue;
        const counts = result.counts.map((quantity, index) => quantity + prefixCounts[index]);
        candidates.push(makePurchasePlan(counts, variants, targetMl));
      }
    }
    const options = filterDominatedOptions(candidates);
    const cheapestPlan = [...options].sort((a,b) =>
      a.totalPrice - b.totalPrice ||
      a.count - b.count ||
      a.distinctSizeCount - b.distinctSizeCount ||
      a.leftoverMl - b.leftoverMl
    )[0] || null;
    return {
      plan:chooseRecommendedOption(options, policy),
      cheapestPlan
    };
  }

  function filterDominatedOptions(options){
    const priceTolerance = 0.005;
    return (options || []).filter((candidate, candidateIndex) => {
      const dominator = options.find((other, otherIndex) => {
        if(candidateIndex === otherIndex) return false;
        const coversAtLeastAsMuch = other.totalMl >= candidate.totalMl - 0.0001;
        const costsNoMore = other.totalPrice <= candidate.totalPrice + priceTolerance;
        if(!coversAtLeastAsMuch || !costsNoMore) return false;
        const sameVolume = Math.abs(other.totalMl - candidate.totalMl) < 0.0001;
        const samePrice = Math.abs(other.totalPrice - candidate.totalPrice) <= priceTolerance;
        if(sameVolume && samePrice) return other.count < candidate.count;
        return other.totalMl > candidate.totalMl + 0.0001 || other.totalPrice < candidate.totalPrice - priceTolerance;
      });
      return !dominator;
    });
  }

  function chooseRecommendedOption(options, policy){
    const eligible = (options || []).filter(option => option.distinctSizeCount <= policy.maxRecommendationSizeTypes);
    if(!eligible.length) return null;
    const cheapestTotal = Math.min(...eligible.map(option => option.totalPrice));
    const simplicityCandidates = eligible.filter(option =>
      option.totalPrice <= cheapestTotal * (1 + policy.simplicityBand) + 0.005
    );
    return simplicityCandidates.sort((a,b) =>
      a.count - b.count ||
      a.distinctSizeCount - b.distinctSizeCount ||
      a.totalPrice - b.totalPrice ||
      a.leftoverMl - b.leftoverMl ||
      a.costPerLitre - b.costPerLitre ||
      b.ml - a.ml
    )[0] || null;
  }

  function findQualifiedUpsell(generatedVariants, manualOptions, recommendation){
    if(!recommendation?.items?.length || !recommendation.costPerLitre) return null;
    const ladder = [...(generatedVariants || [])].sort((a,b) => a.ml - b.ml || a.price - b.price);
    const largestSelectedMl = Math.max(...recommendation.items.map(item => Number(item.ml || 0)));
    const currentIndex = ladder.findIndex(variant => Math.abs(variant.ml - largestSelectedMl) < 0.01);
    const nextVariant = currentIndex >= 0 ? ladder[currentIndex + 1] : null;
    if(!nextVariant) return null;
    const option = (manualOptions || []).find(plan => plan.variantId === nextVariant.id);
    if(!option || option.count !== 1) return null;
    const savingRate = (recommendation.costPerLitre - option.costPerLitre) / recommendation.costPerLitre;
    if(savingRate < UPSIZE_SAVING_THRESHOLD) return null;
    if(option.totalPrice > recommendation.totalPrice * UPSIZE_TOTAL_MULTIPLIER) return null;
    return option;
  }

  function samePurchasePlan(first, second){
    return Boolean(first?.planKey && second?.planKey && first.planKey === second.planKey);
  }

  function spareVolumeCopy(spareMl, isRecommendation){
    return wfT("{0} leaves {1} spare for transfer losses or future batches.", [isRecommendation ? 'The recommended order' : 'Your selected order', formatComputedVolume(spareMl)]);
  }

  function isWeightUnit(unit){
    return ['kg', 'g', 'lb', 'oz'].includes(unit);
  }

  function measurementBasis(unit){
    return isWeightUnit(unit) ? 'weight' : 'volume';
  }

  function weightToKg(value, unit){
    if(unit === 'g') return value / 1000;
    if(unit === 'lb') return value * GRAMS_PER_POUND / 1000;
    if(unit === 'oz') return value * GRAMS_PER_OUNCE / 1000;
    return value;
  }

  function weightFromKg(value, unit){
    if(unit === 'g') return value * 1000;
    if(unit === 'lb') return value * 1000 / GRAMS_PER_POUND;
    if(unit === 'oz') return value * 1000 / GRAMS_PER_OUNCE;
    return value;
  }

  function measurementToBase(value, unit){
    return isWeightUnit(unit) ? weightToKg(value, unit) : volumeToLitres(value, unit);
  }

  function positiveDensity(raw){
    if(raw === null || raw === undefined || String(raw).trim() === '') return null;
    const value = parseDecimal(raw);
    return Number.isFinite(value) && value > 0 ? value : null;
  }

  function convertMeasurement(value, unit, basis, density){
    const amount = measurementToBase(value, unit);
    if(measurementBasis(unit) === basis) return amount;
    if(!positiveDensity(density)) return null;
    return basis === 'weight' ? amount * density : amount / density;
  }

  function flavourAmounts(batchBase, basis, usage, density){
    const amount = batchBase * Math.max(0, usage) / 100;
    if(basis === 'weight') return { neededKg:amount, neededMl:amount === 0 ? 0 : positiveDensity(density) ? amount * 1000 / density : null };
    return { neededMl:amount * 1000, neededKg:positiveDensity(density) ? amount * density : null };
  }

  function specificGravityRange(raw){
    if(raw === null || raw === undefined) return null;
    // A temperature is metadata, never another SG reading. Do not average unrelated numbers.
    const text = String(raw).replace(/<[^>]*>/g, ' ').replace(/&(?:nbsp|deg);/gi, ' ')
      .replace(/\(?\s*\d+(?:[.,]\d+)?\s*(?:°\s*)?[CF]\s*(?:\/\s*\d+(?:[.,]\d+)?\s*(?:°\s*)?[CF])?\s*\)?/gi, ' ')
      .replace(/(?:specific\s*gravity|s\.?g\.?|relative\s*density|at|@|:|=|\(|\))/gi, ' ').trim();
    const match = text.match(/^(\d+(?:[.,]\d+)?)\s*(?:(?:-|–|—|to)\s*(\d+(?:[.,]\d+)?))?\s*$/i);
    if(!match) return null;
    const first = positiveDensity(match[1]);
    const second = match[2] ? positiveDensity(match[2]) : first;
    return first && second ? { low:Math.min(first,second), high:Math.max(first,second) } : null;
  }

  function flavourDensity(row){
    if(row.densityOverride !== null && row.densityOverride !== undefined){
      const value = positiveDensity(row.densityOverride);
      return { value, estimated:false, note:value ? wfT("Entered density. Use a value at the measuring temperature.") : wfT("Enter a positive density to estimate volume and cost.") };
    }
    const explicit = positiveDensity(row.product?.densityRaw);
    if(explicit) return { value:explicit, estimated:false, note:wfT("From the product density specification.") };
    const range = specificGravityRange(row.product?.sgRaw);
    // SG is dimensionless. Without both reference temperatures, g/mL is only an estimate.
    // Use the low end of a range so purchasing volume is not understated by a midpoint.
    if(range) return { value:range.low, estimated:true, note:range.low !== range.high
      ? wfT("Estimated from the low end of product SG {0} to {1} to allow enough flavour. Edit if you have a measured density.", [formatNumber(range.low,4), formatNumber(range.high,4)])
      : wfT("Estimated from product SG {0}. Edit if you have a measured density.", [formatNumber(range.low,4)]) };
    return { value:null, estimated:false, note:wfT("Enter the flavour density from its specification to estimate volume and cost.") };
  }

  function formatWeight(kg){
    const unit = currentBatchUnit();
    if(unit === 'lb' || unit === 'oz') return formatVolumeAmount(weightFromKg(kg, unit), unit);
    return kg >= 1 ? formatVolumeAmount(kg, 'kg') : formatVolumeAmount(kg * 1000, 'g');
  }

  function formatRequiredAmount(detail){
    if(!isWeightUnit(currentBatchUnit())) return formatVolumeForBatchUnit(detail.neededMl);
    return `${formatWeight(detail.neededKg)}${detail.neededMl !== null ? ` · ≈ ${formatComputedVolume(detail.neededMl)}` : ''}`;
  }

  function syncMeasurementControls(basis, pending){
    if(basisNoticeEl) basisNoticeEl.hidden = !pending;
    const batchHelp = root.querySelector('[id^="WFCalcBatchHelp-"]');
    if(batchHelp) batchHelp.textContent = basis === 'weight' ? wfT("Total mixture weight, including flavour; not flour weight") : wfT("Total mixture, including flavour");
    if(basisMessageEl) basisMessageEl.textContent = wfT("Usage is now a percentage by {0}. Check your rates before continuing.", [basis]);
    if(confirmBasisEl) confirmBasisEl.textContent = wfT("Use rates by {0}", [basis]);
    state.rows.forEach((row, rowIndex) => {
      const el = rowsEl.querySelector(`[data-row-id="${row.id}"]`);
      const label = el?.querySelector('[data-row-basis]');
      if(label) label.textContent = wfT("By {0}", [basis]);
      const input = el?.querySelector('[data-usage]');
      if(input) input.setAttribute('aria-label', wfT("Usage rate for {0} (% by {1})", [displayTitle(row.product) || wfT("Flavour {0}", [rowIndex + 1]), basis]));
      const density = flavourDensity(row);
      const densityWrap = el?.querySelector('[data-row-density-wrap]');
      const densitySummary = el?.querySelector('[data-row-density-summary]');
      if(densitySummary) densitySummary.textContent = density.value ? wfT("Flavour density: {0} g/mL", [formatNumber(density.value, 4)]) : wfT("Enter flavour density");
      if(densityWrap && !density.value) densityWrap.open = true;
      const isTestTarget = row.id === state.testBatch.targetRowId;
      const mixedTest = isTestTarget && measurementBasis(state.testBatch.unit) !== measurementBasis(state.testBatch.flavourUnit);
      if(densityWrap) densityWrap.hidden = basis !== 'weight' && !mixedTest;
      const densityInput = el?.querySelector('[data-row-density]');
      if(densityInput && document.activeElement !== densityInput) densityInput.value = formatDecimalInput(row.densityOverride ?? density.value);
      const hint = el?.querySelector('[data-row-density-help]');
      if(hint) hint.textContent = density.note;
    });
    if(calculationNoteEl) calculationNoteEl.textContent = wfT("Usage is a percentage of the total mixture by {0}, including flavour. Weight percentages use the whole mixture, not flour weight. SG is treated as approximate density in g/mL; a range uses its low end for purchasing. Use measured density at the relevant temperature for a closer estimate.", [basis]);
  }

  function packageMeasurement(select, custom, unitSelect){
    const option = select?.options?.[select.selectedIndex];
    const isCustom = select?.value === 'custom';
    const amount = parseDecimal(isCustom ? custom?.value : option?.dataset.amount);
    const unit = isCustom ? unitSelect?.value : option?.dataset.unit;
    return { amount, unit, basis:measurementBasis(unit), base:measurementToBase(amount, unit),
      label:isCustom ? formatVolumeAmount(amount,unit) : (option?.text || 'package') };
  }

  function packageCountFromBatch(batchBase, basis, measurement, density){
    if(!(batchBase > 0) || !(measurement.base > 0)) return null;
    let available = batchBase;
    if(basis !== measurement.basis){
      if(!positiveDensity(density)) return null;
      available = measurement.basis === 'weight' ? batchBase * density : batchBase / density;
    }
    const count = available / measurement.base;
    return Number.isFinite(count) && count > 0 ? count : null;
  }

  function finishedPackageCalculation(batchBase, basis){
    const countMode = packageEl.value === 'count';
    const measurement = packageMeasurement(packageEl, customPackageEl, customPackageUnitEl);
    const crossBasis = !countMode && measurement.basis !== basis;
    if(finishedCountWrap) finishedCountWrap.hidden = !countMode;
    if(mixtureDensityWrap) mixtureDensityWrap.hidden = !crossBasis;
    if(customPackageWrap) customPackageWrap.hidden = packageEl.value !== 'custom';
    const enteredCount = Number(finishedCountEl?.value);
    const count = countMode ? (Number.isInteger(enteredCount) && enteredCount > 0 ? enteredCount : null)
      : packageCountFromBatch(batchBase, basis, measurement, positiveDensity(mixtureDensityEl?.value));
    const error = count ? '' : countMode ? wfT("Enter the whole number of saleable packages or pieces.")
      : !(measurement.base > 0) ? wfT("Enter a positive package or piece size.")
      : crossBasis ? wfT("Enter finished product density or use finished package count.") : wfT("Enter a positive batch size.");
    const assumption = countMode ? wfT("Cost uses the entered saleable package or piece count.") : wfT("Assumes the batch quantity matches packaged output. Use finished count for process losses or added air.");
    if(packageNoteEl) packageNoteEl.textContent = error || assumption;
    return { count, label:countMode ? wfT("finished unit") : measurement.label, error, assumption };
  }

  function mixturePriceUnit(){
    return isWeightUnit(currentBatchUnit()) ? (['lb','oz'].includes(currentBatchUnit()) ? 'lb' : 'kg') : computedPriceUnitLabel();
  }

  function mixtureUnitCost(cost, batchBase){
    if(!(batchBase > 0)) return 0;
    const perBase = cost / batchBase;
    return isWeightUnit(currentBatchUnit()) ? (mixturePriceUnit() === 'lb' ? perBase * GRAMS_PER_POUND / 1000 : perBase) : costPerComputedVolume(perBase);
  }

  function parseSgText(text){
    if(!text) return '';
    const clean = stripHtml(text).replace(/\(?\s*(?:at|@)?\s*\d+(?:[.,]\d+)?\s*(?:°\s*)?[CF]\s*\)?/gi, ' ');
    const match = clean.match(/specific\s*gravity\s*[:=(]?\s*(\d+(?:[.,]\d+)?\s*(?:(?:-|–|—|to)\s*\d+(?:[.,]\d+)?)?)/i);
    return match ? match[1].trim() : '';
  }
  function parseBottleMl(title){ const t = String(title).toLowerCase(); const n = Number((t.match(/\d+(?:\.\d+)?/) || [0])[0]); if(!n) return 0; if(t.includes('gal')) return n * ML_PER_US_GALLON; if(t.includes('ml')) return n; if(/\bl\b|litre|liter/.test(t) && !t.includes('ml')) return n * 1000; if(t.includes('oz')) return n * ML_PER_US_OZ; return 0; }
  function currentBatchUnit(){ return batchUnitEl?.value || 'L'; }
  function parseDecimal(value){
    const text = String(value ?? '').trim();
    if(text === '') return 0;
    if(!/^[+-]?(?:\d+(?:[.,]\d*)?|[.,]\d+)(?:[eE][+-]?\d+)?$/.test(text)) return NaN;
    return Number(text.replace(',', '.'));
  }
  function currentBatchSize(){ return parseDecimal(batchSizeEl?.value || 0) || 0; }
  function unitLabel(unit){
    return ({ gal_us:wfT('US gal'), fl_oz:wfT("US fl oz"), ml:'mL', hL:'hL', bbl_us:wfT('US beer bbl'), kg:'kg', lb:'lb', g:'g', oz:wfT("oz (weight)") })[unit] || 'L';
  }

  function formatVolumeAmount(value, unit){
    const n = Number(value || 0);
    const rounded = roundVolumeValue(n);
    return `${formatNumber(rounded, volumeFractionDigits(rounded))} ${unitLabel(unit)}`;
  }
  function formatBatchInputLabel(batchL){
    const unit = currentBatchUnit();
    const inputValue = currentBatchSize();
    const amount = inputValue > 0 ? inputValue : (isWeightUnit(unit) ? weightFromKg(batchL, unit) : volumeFromLitres(batchL, unit));
    return `${formatNumber(amount, 12)} ${unitLabel(unit)}`;
  }
  function formatVolumeForBatchUnit(ml){
    const unit = currentBatchUnit();
    if(unit === 'gal_us') return formatVolumeAmount(Number(ml || 0) / ML_PER_US_GALLON, 'gal_us');
    if(unit === 'fl_oz') return formatVolumeAmount(Number(ml || 0) / ML_PER_US_OZ, 'fl_oz');
    if(unit === 'ml') return formatVolumeAmount(Number(ml || 0), 'ml');
    return formatVolumeAmount(Number(ml || 0) / 1000, 'L');
  }
  function usesUsComputedUnits(){
    return ['gal_us','fl_oz','bbl_us','lb','oz'].includes(currentBatchUnit());
  }
  function computedPriceUnitLabel(){
    return usesUsComputedUnits() ? 'US gallon' : 'L';
  }
  function costPerComputedVolume(costPerLitre){
    const value = Number(costPerLitre || 0);
    return usesUsComputedUnits() ? value * (ML_PER_US_GALLON / 1000) : value;
  }
  function formatComputedUnitPrice(costPerLitre){
    return `${fmtUnitCost(costPerComputedVolume(costPerLitre))} / ${computedPriceUnitLabel()}`;
  }
  function formatComputedVolume(ml){
    const value = Math.max(0, Number(ml || 0));
    if(usesUsComputedUnits()){
      if(value >= ML_PER_US_GALLON) return formatVolumeAmount(value / ML_PER_US_GALLON, 'gal_us');
      return formatVolumeAmount(value / ML_PER_US_OZ, 'fl_oz');
    }
    if(value >= 1000) return formatVolumeAmount(value / 1000, 'L');
    return formatMillilitres(value);
  }
  function volumeToLitres(value, unit){
    if(unit === 'gal_us') return value * ML_PER_US_GALLON / 1000;
    if(unit === 'bbl_us') return value * 31 * ML_PER_US_GALLON / 1000;
    if(unit === 'hL') return value * 100;
    if(unit === 'fl_oz') return value * ML_PER_US_OZ / 1000;
    if(unit === 'ml') return value / 1000;
    return unit === 'L' ? value : NaN;
  }

  function volumeFromLitres(value, unit){
    return value / volumeToLitres(1, unit);
  }

  function formatDecimalInput(value){
    const raw = String(value ?? '');
    return Number.isFinite(parseDecimal(raw)) ? raw.replace(isFrench ? '.' : ',', isFrench ? ',' : '.') : raw;
  }
  function numForInput(value){ return formatDecimalInput(Math.round(Number(value || 0) * 1000) / 1000); }
  function numForBatchInput(value){ return formatDecimalInput(Number(value || 0)); }
  function normalizeProduct(p){
    if(!p) return null;
    if(Array.isArray(p)) p = { title:p[0], handle:p[1], sku:p[2], image:p[3], sgRaw:p[4], densityRaw:p[5] };
    // Use the same sample-pack identity as the product page, including translated titles.
    if(sanitizeProductHandle(p.handle) === 'free-samples-for-businesses' || cleanProductTitle(p.title).toLowerCase() === 'free samples for businesses') return null;
    const title = catalogueTitles.get(sanitizeProductHandle(p.handle)) || p.title;
    return { ...p, title:cleanProductTitle(title), image:normalizeImageSource(p.image || p.featured_image), variants:(p.variants||[]).map(v=>({...v, priceCents:Number(v.priceCents ?? v.price ?? 0)})) };
  }
  function cleanProductTitle(title){
    // Resolve translated aliases after removing descriptions, before removing generic labels.
    const baseTitle = String(title || '').trim()
      .replace(/\s*:\s*Liquid Concentrate for Food\s*&\s*Beverage Producers\s*$/i, '')
      .replace(/\s*:\s*concentr[ée]\s+liquide\b.*$/i, '')
      .replace(/\s+pour\s+producteurs\s+alimentaires\s*(?:&|et)\s+de\s+boissons\s*$/i, '');
    const name = wfT(baseTitle).trim()
      .replace(/^(?:boisson\s+concentr[ée]e?\s+)?(?:ar[oô]mes?|saveurs?|go[ûu]t)\s+(?:de\s+|d['’]\s*)?/i, '')
      .replace(/^((?:naturel(?:le)?\s+)?)(?:concentr[ée](?:\s+liquide)?\s+)(?:de\s+|d['’]\s*)?/i, '$1')
      .replace(/^(naturel(?:le)?\s+)(?:de\s+|d['’]\s*)/i, '$1')
      .replace(/\s+\(?(?:ar[oô]mes?|saveurs?)\)?\s*$/i, '')
      .replace(/^\(([^()]+)\)$/, '$1')
      .trim();
    return name.charAt(0).toUpperCase() + name.slice(1);
  }
  function displayTitle(product){ return cleanProductTitle(product?.title || ''); }
  function normalizeImageSource(value){
    if(!value) return '';
    if(Array.isArray(value)) return normalizeImageSource(value[0]);
    const source = typeof value === 'object' ? String(value.url || value.src || value.originalSrc || '') : String(value);
    const media = globalThis.wfStorefrontMedia;
    return media ? media.url(source) : source;
  }
  function productThumbnail(product){
    if(!product) return '';
    const image = normalizeImageSource(product.image);
    if(image) return `<span class="wfcalc2__thumb" aria-hidden="true"><img src="${escapeAttr(image)}" alt="" width="40" height="40" loading="lazy" decoding="async"></span>`;
    const initial = displayTitle(product).charAt(0).toUpperCase() || 'W';
    return `<span class="wfcalc2__thumb" aria-hidden="true">${escapeHtml(initial)}</span>`;
  }
  function baseSku(sku){ return String(sku || '').replace(/-[^-]{1,3}$/, ''); }
  function formatNumber(value, maximumFractionDigits = 2, minimumFractionDigits = 0){
    return Number(value || 0).toLocaleString(numberLocale, { minimumFractionDigits, maximumFractionDigits });
  }
  function formatPercent(value){ return `${formatNumber(value, 3)}%`; }
  function roundVolumeValue(value){
    const amount = Number(value || 0);
    const absolute = Math.abs(amount);
    if(!Number.isFinite(amount) || absolute === 0) return 0;
    const decimalPlaces = 2 - Math.floor(Math.log10(absolute));
    if(decimalPlaces >= 0){
      const factor = 10 ** decimalPlaces;
      return Math.round((amount + Number.EPSILON) * factor) / factor;
    }
    const factor = 10 ** -decimalPlaces;
    return Math.round(amount / factor) * factor;
  }
  function volumeFractionDigits(value){
    const absolute = Math.abs(Number(value || 0));
    if(!absolute) return 0;
    return Math.max(0, Math.min(12, 2 - Math.floor(Math.log10(absolute))));
  }
  function formatMillilitres(value){
    const amount = roundVolumeValue(value);
    return `${formatNumber(amount, volumeFractionDigits(amount))} mL`;
  }
  function searchableText(p){ return normalizeSearch(`${p.title || ''} ${p.sku || ''} ${p.handle || ''} ${(p.variants||[]).map(v=>`${v.sku||''} ${v.title||''}`).join(' ')}`); }
  function normalizeSearch(value){
    // Search spelling only: Keep the customer's text and displayed content intact.
    return String(value || '').normalize('NFD').replace(/\p{M}/gu, '').toLowerCase()
      .replace(/œ/g, 'oe').replace(/æ/g, 'ae')
      .replace(/[^\p{L}\p{N}.]+/gu, ' ').trim();
  }
  function matchesQuery(product, query){
    const normalized = normalizeSearch(query);
    const compactQuery = normalized.replace(/\s/g, '');
    if(/^(?:sc|nc|rc)\s*\d+(?:\s*(?:\d+g?|tt))?$/.test(normalized)){
      return product.matchedSkuQuery === compactQuery || [product.sku, ...(product.variants || []).map(variant => variant.sku)]
        .some(sku => normalizeSearch(sku).replace(/\s/g, '').startsWith(compactQuery));
    }
    const haystack = searchableText(product);
    return normalized.split(' ').filter(Boolean).every(token => haystack.includes(token))
      || haystack.replace(/\s/g, '').includes(compactQuery);
  }
  function dedupeProducts(arr){ const map = new Map(); arr.filter(Boolean).forEach(p => { const key = String(p.handle || ''); if(key && !map.has(key)) map.set(key, p); }); return [...map.values()].sort((a,b)=>String(a.title).localeCompare(String(b.title))); }
  function fmtMoney(value){
    const amount = Number(value || 0);
    return isFrench ? `${formatNumber(amount, 2, 2)} ${moneySymbol}` : `${moneySymbol}${formatNumber(amount, 2, 2)}`;
  }
  function fmtUnitCost(value){
    const amount = Number(value || 0);
    const formatted = amount > 0 && amount < 1
      ? `${formatNumber(amount * 100, 1)}¢`
      : fmtMoney(amount);
    return formatted;
  }
  function stripHtml(s){ const tmp = document.createElement('div'); tmp.innerHTML = String(s||''); return tmp.textContent || tmp.innerText || ''; }
  function escapeHtml(s){ return String(s || '').replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c])); }
  function escapeAttr(s){ return escapeHtml(s).replace(/`/g,'&#96;'); }
  function safeJson(text, fallback){ try{return JSON.parse(text)}catch(e){return fallback} }
  function uid(){ return Math.random().toString(36).slice(2) + Date.now().toString(36); }
  function debounce(fn, wait){ let t; return (...args)=>{ clearTimeout(t); t=setTimeout(()=>fn(...args), wait); }; }
}

function initCalculators(scope){
  if(scope.matches?.(CALCULATOR_SELECTOR)) initCalculator(scope);
  if(scope.querySelectorAll) scope.querySelectorAll(CALCULATOR_SELECTOR).forEach(initCalculator);
}

initCalculators(document);
document.addEventListener('shopify:section:load', event => initCalculators(event.target));

  } catch(e) { console.error(e); }
})();
})();
